window.jQuery || function(e, t) {
    "object" == typeof module && "object" == typeof module.exports ? module.exports = e.document ? t(e, !0) : function(e) {
        if (!e.document) throw new Error("jQuery requires a window with a document");
        return t(e)
    } : t(e)
}("undefined" != typeof window ? window : this, function(h, e) {
    function t(e, t) {
        return t.toUpperCase()
    }
    var u = [],
        d = u.slice,
        m = u.concat,
        s = u.push,
        r = u.indexOf,
        n = {},
        i = n.toString,
        g = n.hasOwnProperty,
        a = "".trim,
        v = {},
        o = "1.11.0",
        T = function(e, t) {
            return new T.fn.init(e, t)
        },
        l = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
        c = /^-ms-/,
        p = /-([\da-z])/gi;

    function f(e) {
        var t = e.length,
            n = T.type(e);
        return "function" !== n && !T.isWindow(e) && (!(1 !== e.nodeType || !t) || ("array" === n || 0 === t || "number" == typeof t && 0 < t && t - 1 in e))
    }
    T.fn = T.prototype = {
        jquery: o,
        constructor: T,
        selector: "",
        length: 0,
        toArray: function() {
            return d.call(this)
        },
        get: function(e) {
            return null != e ? e < 0 ? this[e + this.length] : this[e] : d.call(this)
        },
        pushStack: function(e) {
            var t = T.merge(this.constructor(), e);
            return t.prevObject = this, t.context = this.context, t
        },
        each: function(e, t) {
            return T.each(this, e, t)
        },
        map: function(n) {
            return this.pushStack(T.map(this, function(e, t) {
                return n.call(e, t, e)
            }))
        },
        slice: function() {
            return this.pushStack(d.apply(this, arguments))
        },
        first: function() {
            return this.eq(0)
        },
        last: function() {
            return this.eq(-1)
        },
        eq: function(e) {
            var t = this.length,
                n = +e + (e < 0 ? t : 0);
            return this.pushStack(0 <= n && n < t ? [this[n]] : [])
        },
        end: function() {
            return this.prevObject || this.constructor(null)
        },
        push: s,
        sort: u.sort,
        splice: u.splice
    }, T.extend = T.fn.extend = function() {
        var e, t, n, i, r, a, o = arguments[0] || {},
            s = 1,
            l = arguments.length,
            c = !1;
        for ("boolean" == typeof o && (c = o, o = arguments[s] || {}, s++), "object" == typeof o || T.isFunction(o) || (o = {}), s === l && (o = this, s--); s < l; s++)
            if (null != (r = arguments[s]))
                for (i in r) e = o[i], o !== (n = r[i]) && (c && n && (T.isPlainObject(n) || (t = T.isArray(n))) ? (a = t ? (t = !1, e && T.isArray(e) ? e : []) : e && T.isPlainObject(e) ? e : {}, o[i] = T.extend(c, a, n)) : void 0 !== n && (o[i] = n));
        return o
    }, T.extend({
        expando: "jQuery" + (o + Math.random()).replace(/\D/g, ""),
        isReady: !0,
        error: function(e) {
            throw new Error(e)
        },
        noop: function() {},
        isFunction: function(e) {
            return "function" === T.type(e)
        },
        isArray: Array.isArray || function(e) {
            return "array" === T.type(e)
        },
        isWindow: function(e) {
            return null != e && e == e.window
        },
        isNumeric: function(e) {
            return 0 <= e - parseFloat(e)
        },
        isEmptyObject: function(e) {
            var t;
            for (t in e) return !1;
            return !0
        },
        isPlainObject: function(e) {
            var t;
            if (!e || "object" !== T.type(e) || e.nodeType || T.isWindow(e)) return !1;
            try {
                if (e.constructor && !g.call(e, "constructor") && !g.call(e.constructor.prototype, "isPrototypeOf")) return !1
            } catch (e) {
                return !1
            }
            if (v.ownLast)
                for (t in e) return g.call(e, t);
            for (t in e);
            return void 0 === t || g.call(e, t)
        },
        type: function(e) {
            return null == e ? e + "" : "object" == typeof e || "function" == typeof e ? n[i.call(e)] || "object" : typeof e
        },
        globalEval: function(e) {
            e && T.trim(e) && (h.execScript || function(e) {
                h.eval.call(h, e)
            })(e)
        },
        camelCase: function(e) {
            return e.replace(c, "ms-").replace(p, t)
        },
        nodeName: function(e, t) {
            return e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase()
        },
        each: function(e, t, n) {
            var i = 0,
                r = e.length,
                a = f(e);
            if (n) {
                if (a)
                    for (; i < r && !1 !== t.apply(e[i], n); i++);
                else
                    for (i in e)
                        if (!1 === t.apply(e[i], n)) break
            } else if (a)
                for (; i < r && !1 !== t.call(e[i], i, e[i]); i++);
            else
                for (i in e)
                    if (!1 === t.call(e[i], i, e[i])) break; return e
        },
        trim: a && !a.call("\ufeffÂ ") ? function(e) {
            return null == e ? "" : a.call(e)
        } : function(e) {
            return null == e ? "" : (e + "").replace(l, "")
        },
        makeArray: function(e, t) {
            var n = t || [];
            return null != e && (f(Object(e)) ? T.merge(n, "string" == typeof e ? [e] : e) : s.call(n, e)), n
        },
        inArray: function(e, t, n) {
            var i;
            if (t) {
                if (r) return r.call(t, e, n);
                for (i = t.length, n = n ? n < 0 ? Math.max(0, i + n) : n : 0; n < i; n++)
                    if (n in t && t[n] === e) return n
            }
            return -1
        },
        merge: function(e, t) {
            for (var n = +t.length, i = 0, r = e.length; i < n;) e[r++] = t[i++];
            if (n != n)
                for (; void 0 !== t[i];) e[r++] = t[i++];
            return e.length = r, e
        },
        grep: function(e, t, n) {
            for (var i = [], r = 0, a = e.length, o = !n; r < a; r++) !t(e[r], r) != o && i.push(e[r]);
            return i
        },
        map: function(e, t, n) {
            var i, r = 0,
                a = e.length,
                o = [];
            if (f(e))
                for (; r < a; r++) null != (i = t(e[r], r, n)) && o.push(i);
            else
                for (r in e) null != (i = t(e[r], r, n)) && o.push(i);
            return m.apply([], o)
        },
        guid: 1,
        proxy: function(e, t) {
            var n, i, r;
            return "string" == typeof t && (r = e[t], t = e, e = r), T.isFunction(e) ? (n = d.call(arguments, 2), (i = function() {
                return e.apply(t || this, n.concat(d.call(arguments)))
            }).guid = e.guid = e.guid || T.guid++, i) : void 0
        },
        now: function() {
            return +new Date
        },
        support: v
    }), T.each("Boolean Number String Function Array Date RegExp Object Error".split(" "), function(e, t) {
        n["[object " + t + "]"] = t.toLowerCase()
    });
    var _ = function(n) {
        var e, h, b, a, i, m, x, c, d, g, w, r, v, _, o, s, y, T = "sizzle" + -new Date,
            C = n.document,
            k = 0,
            u = 0,
            l = ne(),
            p = ne(),
            f = ne(),
            E = function(e, t) {
                return e === t && (d = !0), 0
            },
            N = "undefined",
            S = {}.hasOwnProperty,
            t = [],
            $ = t.pop,
            A = t.push,
            D = t.push,
            j = t.slice,
            M = t.indexOf || function(e) {
                for (var t = 0, n = this.length; t < n; t++)
                    if (this[t] === e) return t;
                return -1
            },
            L = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
            H = "[\\x20\\t\\r\\n\\f]",
            q = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",
            W = q.replace("w", "w#"),
            P = "\\[" + H + "*(" + q + ")" + H + "*(?:([*^$|!~]?=)" + H + "*(?:(['\"])((?:\\\\.|[^\\\\])*?)\\3|(" + W + ")|)|)" + H + "*\\]",
            O = ":(" + q + ")(?:\\(((['\"])((?:\\\\.|[^\\\\])*?)\\3|((?:\\\\.|[^\\\\()[\\]]|" + P.replace(3, 8) + ")*)|.*)\\)|)",
            B = new RegExp("^" + H + "+|((?:^|[^\\\\])(?:\\\\.)*)" + H + "+$", "g"),
            F = new RegExp("^" + H + "*," + H + "*"),
            z = new RegExp("^" + H + "*([>+~]|" + H + ")" + H + "*"),
            I = new RegExp("=" + H + "*([^\\]'\"]*?)" + H + "*\\]", "g"),
            R = new RegExp(O),
            X = new RegExp("^" + W + "$"),
            V = {
                ID: new RegExp("^#(" + q + ")"),
                CLASS: new RegExp("^\\.(" + q + ")"),
                TAG: new RegExp("^(" + q.replace("w", "w*") + ")"),
                ATTR: new RegExp("^" + P),
                PSEUDO: new RegExp("^" + O),
                CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + H + "*(even|odd|(([+-]|)(\\d*)n|)" + H + "*(?:([+-]|)" + H + "*(\\d+)|))" + H + "*\\)|)", "i"),
                bool: new RegExp("^(?:" + L + ")$", "i"),
                needsContext: new RegExp("^" + H + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + H + "*((?:-\\d)?\\d*)" + H + "*\\)|)(?=[^-]|$)", "i")
            },
            Y = /^(?:input|select|textarea|button)$/i,
            U = /^h\d$/i,
            G = /^[^{]+\{\s*\[native \w/,
            Q = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
            J = /[+~]/,
            K = /'|\\/g,
            Z = new RegExp("\\\\([\\da-f]{1,6}" + H + "?|(" + H + ")|.)", "ig"),
            ee = function(e, t, n) {
                var i = "0x" + t - 65536;
                return i != i || n ? t : i < 0 ? String.fromCharCode(65536 + i) : String.fromCharCode(i >> 10 | 55296, 1023 & i | 56320)
            };
        try {
            D.apply(t = j.call(C.childNodes), C.childNodes), t[C.childNodes.length].nodeType
        } catch (e) {
            D = {
                apply: t.length ? function(e, t) {
                    A.apply(e, j.call(t))
                } : function(e, t) {
                    for (var n = e.length, i = 0; e[n++] = t[i++];);
                    e.length = n - 1
                }
            }
        }

        function te(e, t, n, i) {
            var r, a, o, s, l, c, d, u, p, f;
            if ((t ? t.ownerDocument || t : C) !== w && g(t), n = n || [], !e || "string" != typeof e) return n;
            if (1 !== (s = (t = t || w).nodeType) && 9 !== s) return [];
            if (v && !i) {
                if (r = Q.exec(e))
                    if (o = r[1]) {
                        if (9 === s) {
                            if (!(a = t.getElementById(o)) || !a.parentNode) return n;
                            if (a.id === o) return n.push(a), n
                        } else if (t.ownerDocument && (a = t.ownerDocument.getElementById(o)) && y(t, a) && a.id === o) return n.push(a), n
                    } else {
                        if (r[2]) return D.apply(n, t.getElementsByTagName(e)), n;
                        if ((o = r[3]) && h.getElementsByClassName && t.getElementsByClassName) return D.apply(n, t.getElementsByClassName(o)), n
                    }
                if (h.qsa && (!_ || !_.test(e))) {
                    if (u = d = T, p = t, f = 9 === s && e, 1 === s && "object" !== t.nodeName.toLowerCase()) {
                        for (c = pe(e), (d = t.getAttribute("id")) ? u = d.replace(K, "\\$&") : t.setAttribute("id", u), u = "[id='" + u + "'] ", l = c.length; l--;) c[l] = u + fe(c[l]);
                        p = J.test(e) && de(t.parentNode) || t, f = c.join(",")
                    }
                    if (f) try {
                        return D.apply(n, p.querySelectorAll(f)), n
                    } catch (e) {} finally {
                        d || t.removeAttribute("id")
                    }
                }
            }
            return function(e, t, n, i) {
                var r, a, o, s, l, c = pe(e);
                if (!i && 1 === c.length) {
                    if (2 < (a = c[0] = c[0].slice(0)).length && "ID" === (o = a[0]).type && h.getById && 9 === t.nodeType && v && b.relative[a[1].type]) {
                        if (!(t = (b.find.ID(o.matches[0].replace(Z, ee), t) || [])[0])) return n;
                        e = e.slice(a.shift().value.length)
                    }
                    for (r = V.needsContext.test(e) ? 0 : a.length; r-- && (o = a[r], !b.relative[s = o.type]);)
                        if ((l = b.find[s]) && (i = l(o.matches[0].replace(Z, ee), J.test(a[0].type) && de(t.parentNode) || t))) {
                            if (a.splice(r, 1), !(e = i.length && fe(a))) return D.apply(n, i), n;
                            break
                        }
                }
                return m(e, c)(i, t, !v, n, J.test(e) && de(t.parentNode) || t), n
            }(e.replace(B, "$1"), t, n, i)
        }

        function ne() {
            var i = [];
            return function e(t, n) {
                return i.push(t + " ") > b.cacheLength && delete e[i.shift()], e[t + " "] = n
            }
        }

        function ie(e) {
            return e[T] = !0, e
        }

        function re(e) {
            var t = w.createElement("div");
            try {
                return !!e(t)
            } catch (e) {
                return !1
            } finally {
                t.parentNode && t.parentNode.removeChild(t), t = null
            }
        }

        function ae(e, t) {
            for (var n = e.split("|"), i = e.length; i--;) b.attrHandle[n[i]] = t
        }

        function oe(e, t) {
            var n = t && e,
                i = n && 1 === e.nodeType && 1 === t.nodeType && (~t.sourceIndex || 1 << 31) - (~e.sourceIndex || 1 << 31);
            if (i) return i;
            if (n)
                for (; n = n.nextSibling;)
                    if (n === t) return -1;
            return e ? 1 : -1
        }

        function se(t) {
            return function(e) {
                return "input" === e.nodeName.toLowerCase() && e.type === t
            }
        }

        function le(n) {
            return function(e) {
                var t = e.nodeName.toLowerCase();
                return ("input" === t || "button" === t) && e.type === n
            }
        }

        function ce(o) {
            return ie(function(a) {
                return a = +a, ie(function(e, t) {
                    for (var n, i = o([], e.length, a), r = i.length; r--;) e[n = i[r]] && (e[n] = !(t[n] = e[n]))
                })
            })
        }

        function de(e) {
            return e && typeof e.getElementsByTagName !== N && e
        }
        for (e in h = te.support = {}, i = te.isXML = function(e) {
            var t = e && (e.ownerDocument || e).documentElement;
            return !!t && "HTML" !== t.nodeName
        }, g = te.setDocument = function(e) {
            var t, l = e ? e.ownerDocument || e : C,
                n = l.defaultView;
            return l !== w && 9 === l.nodeType && l.documentElement ? (r = (w = l).documentElement, v = !i(l), n && n !== n.top && (n.addEventListener ? n.addEventListener("unload", function() {
                g()
            }, !1) : n.attachEvent && n.attachEvent("onunload", function() {
                g()
            })), h.attributes = re(function(e) {
                return e.className = "i", !e.getAttribute("className")
            }), h.getElementsByTagName = re(function(e) {
                return e.appendChild(l.createComment("")), !e.getElementsByTagName("*").length
            }), h.getElementsByClassName = G.test(l.getElementsByClassName) && re(function(e) {
                return e.innerHTML = "<div class='a'></div><div class='a i'></div>", e.firstChild.className = "i", 2 === e.getElementsByClassName("i").length
            }), h.getById = re(function(e) {
                return r.appendChild(e).id = T, !l.getElementsByName || !l.getElementsByName(T).length
            }), h.getById ? (b.find.ID = function(e, t) {
                if (typeof t.getElementById !== N && v) {
                    var n = t.getElementById(e);
                    return n && n.parentNode ? [n] : []
                }
            }, b.filter.ID = function(e) {
                var t = e.replace(Z, ee);
                return function(e) {
                    return e.getAttribute("id") === t
                }
            }) : (delete b.find.ID, b.filter.ID = function(e) {
                var n = e.replace(Z, ee);
                return function(e) {
                    var t = typeof e.getAttributeNode !== N && e.getAttributeNode("id");
                    return t && t.value === n
                }
            }), b.find.TAG = h.getElementsByTagName ? function(e, t) {
                return typeof t.getElementsByTagName !== N ? t.getElementsByTagName(e) : void 0
            } : function(e, t) {
                var n, i = [],
                    r = 0,
                    a = t.getElementsByTagName(e);
                if ("*" !== e) return a;
                for (; n = a[r++];) 1 === n.nodeType && i.push(n);
                return i
            }, b.find.CLASS = h.getElementsByClassName && function(e, t) {
                return typeof t.getElementsByClassName !== N && v ? t.getElementsByClassName(e) : void 0
            }, o = [], _ = [], (h.qsa = G.test(l.querySelectorAll)) && (re(function(e) {
                e.innerHTML = "<select t=''><option selected=''></option></select>", e.querySelectorAll("[t^='']").length && _.push("[*^$]=" + H + "*(?:''|\"\")"), e.querySelectorAll("[selected]").length || _.push("\\[" + H + "*(?:value|" + L + ")"), e.querySelectorAll(":checked").length || _.push(":checked")
            }), re(function(e) {
                var t = l.createElement("input");
                t.setAttribute("type", "hidden"), e.appendChild(t).setAttribute("name", "D"), e.querySelectorAll("[name=d]").length && _.push("name" + H + "*[*^$|!~]?="), e.querySelectorAll(":enabled").length || _.push(":enabled", ":disabled"), e.querySelectorAll("*,:x"), _.push(",.*:")
            })), (h.matchesSelector = G.test(s = r.webkitMatchesSelector || r.mozMatchesSelector || r.oMatchesSelector || r.msMatchesSelector)) && re(function(e) {
                h.disconnectedMatch = s.call(e, "div"), s.call(e, "[s!='']:x"), o.push("!=", O)
            }), _ = _.length && new RegExp(_.join("|")), o = o.length && new RegExp(o.join("|")), t = G.test(r.compareDocumentPosition), y = t || G.test(r.contains) ? function(e, t) {
                var n = 9 === e.nodeType ? e.documentElement : e,
                    i = t && t.parentNode;
                return e === i || !(!i || 1 !== i.nodeType || !(n.contains ? n.contains(i) : e.compareDocumentPosition && 16 & e.compareDocumentPosition(i)))
            } : function(e, t) {
                if (t)
                    for (; t = t.parentNode;)
                        if (t === e) return !0;
                return !1
            }, E = t ? function(e, t) {
                if (e === t) return d = !0, 0;
                var n = !e.compareDocumentPosition - !t.compareDocumentPosition;
                return n || (1 & (n = (e.ownerDocument || e) === (t.ownerDocument || t) ? e.compareDocumentPosition(t) : 1) || !h.sortDetached && t.compareDocumentPosition(e) === n ? e === l || e.ownerDocument === C && y(C, e) ? -1 : t === l || t.ownerDocument === C && y(C, t) ? 1 : c ? M.call(c, e) - M.call(c, t) : 0 : 4 & n ? -1 : 1)
            } : function(e, t) {
                if (e === t) return d = !0, 0;
                var n, i = 0,
                    r = e.parentNode,
                    a = t.parentNode,
                    o = [e],
                    s = [t];
                if (!r || !a) return e === l ? -1 : t === l ? 1 : r ? -1 : a ? 1 : c ? M.call(c, e) - M.call(c, t) : 0;
                if (r === a) return oe(e, t);
                for (n = e; n = n.parentNode;) o.unshift(n);
                for (n = t; n = n.parentNode;) s.unshift(n);
                for (; o[i] === s[i];) i++;
                return i ? oe(o[i], s[i]) : o[i] === C ? -1 : s[i] === C ? 1 : 0
            }, l) : w
        }, te.matches = function(e, t) {
            return te(e, null, null, t)
        }, te.matchesSelector = function(e, t) {
            if ((e.ownerDocument || e) !== w && g(e), t = t.replace(I, "='$1']"), !(!h.matchesSelector || !v || o && o.test(t) || _ && _.test(t))) try {
                var n = s.call(e, t);
                if (n || h.disconnectedMatch || e.document && 11 !== e.document.nodeType) return n
            } catch (e) {}
            return 0 < te(t, w, null, [e]).length
        }, te.contains = function(e, t) {
            return (e.ownerDocument || e) !== w && g(e), y(e, t)
        }, te.attr = function(e, t) {
            (e.ownerDocument || e) !== w && g(e);
            var n = b.attrHandle[t.toLowerCase()],
                i = n && S.call(b.attrHandle, t.toLowerCase()) ? n(e, t, !v) : void 0;
            return void 0 !== i ? i : h.attributes || !v ? e.getAttribute(t) : (i = e.getAttributeNode(t)) && i.specified ? i.value : null
        }, te.error = function(e) {
            throw new Error("Syntax error, unrecognized expression: " + e)
        }, te.uniqueSort = function(e) {
            var t, n = [],
                i = 0,
                r = 0;
            if (d = !h.detectDuplicates, c = !h.sortStable && e.slice(0), e.sort(E), d) {
                for (; t = e[r++];) t === e[r] && (i = n.push(r));
                for (; i--;) e.splice(n[i], 1)
            }
            return c = null, e
        }, a = te.getText = function(e) {
            var t, n = "",
                i = 0,
                r = e.nodeType;
            if (r) {
                if (1 === r || 9 === r || 11 === r) {
                    if ("string" == typeof e.textContent) return e.textContent;
                    for (e = e.firstChild; e; e = e.nextSibling) n += a(e)
                } else if (3 === r || 4 === r) return e.nodeValue
            } else
                for (; t = e[i++];) n += a(t);
            return n
        }, (b = te.selectors = {
            cacheLength: 50,
            createPseudo: ie,
            match: V,
            attrHandle: {},
            find: {},
            relative: {
                ">": {
                    dir: "parentNode",
                    first: !0
                },
                " ": {
                    dir: "parentNode"
                },
                "+": {
                    dir: "previousSibling",
                    first: !0
                },
                "~": {
                    dir: "previousSibling"
                }
            },
            preFilter: {
                ATTR: function(e) {
                    return e[1] = e[1].replace(Z, ee), e[3] = (e[4] || e[5] || "").replace(Z, ee), "~=" === e[2] && (e[3] = " " + e[3] + " "), e.slice(0, 4)
                },
                CHILD: function(e) {
                    return e[1] = e[1].toLowerCase(), "nth" === e[1].slice(0, 3) ? (e[3] || te.error(e[0]), e[4] = +(e[4] ? e[5] + (e[6] || 1) : 2 * ("even" === e[3] || "odd" === e[3])), e[5] = +(e[7] + e[8] || "odd" === e[3])) : e[3] && te.error(e[0]), e
                },
                PSEUDO: function(e) {
                    var t, n = !e[5] && e[2];
                    return V.CHILD.test(e[0]) ? null : (e[3] && void 0 !== e[4] ? e[2] = e[4] : n && R.test(n) && (t = pe(n, !0)) && (t = n.indexOf(")", n.length - t) - n.length) && (e[0] = e[0].slice(0, t), e[2] = n.slice(0, t)), e.slice(0, 3))
                }
            },
            filter: {
                TAG: function(e) {
                    var t = e.replace(Z, ee).toLowerCase();
                    return "*" === e ? function() {
                        return !0
                    } : function(e) {
                        return e.nodeName && e.nodeName.toLowerCase() === t
                    }
                },
                CLASS: function(e) {
                    var t = l[e + " "];
                    return t || (t = new RegExp("(^|" + H + ")" + e + "(" + H + "|$)")) && l(e, function(e) {
                        return t.test("string" == typeof e.className && e.className || typeof e.getAttribute !== N && e.getAttribute("class") || "")
                    })
                },
                ATTR: function(n, i, r) {
                    return function(e) {
                        var t = te.attr(e, n);
                        return null == t ? "!=" === i : !i || (t += "", "=" === i ? t === r : "!=" === i ? t !== r : "^=" === i ? r && 0 === t.indexOf(r) : "*=" === i ? r && -1 < t.indexOf(r) : "$=" === i ? r && t.slice(-r.length) === r : "~=" === i ? -1 < (" " + t + " ").indexOf(r) : "|=" === i && (t === r || t.slice(0, r.length + 1) === r + "-"))
                    }
                },
                CHILD: function(f, e, t, h, m) {
                    var g = "nth" !== f.slice(0, 3),
                        v = "last" !== f.slice(-4),
                        _ = "of-type" === e;
                    return 1 === h && 0 === m ? function(e) {
                        return !!e.parentNode
                    } : function(e, t, n) {
                        var i, r, a, o, s, l, c = g != v ? "nextSibling" : "previousSibling",
                            d = e.parentNode,
                            u = _ && e.nodeName.toLowerCase(),
                            p = !n && !_;
                        if (d) {
                            if (g) {
                                for (; c;) {
                                    for (a = e; a = a[c];)
                                        if (_ ? a.nodeName.toLowerCase() === u : 1 === a.nodeType) return !1;
                                    l = c = "only" === f && !l && "nextSibling"
                                }
                                return !0
                            }
                            if (l = [v ? d.firstChild : d.lastChild], v && p) {
                                for (s = (i = (r = d[T] || (d[T] = {}))[f] || [])[0] === k && i[1], o = i[0] === k && i[2], a = s && d.childNodes[s]; a = ++s && a && a[c] || (o = s = 0) || l.pop();)
                                    if (1 === a.nodeType && ++o && a === e) {
                                        r[f] = [k, s, o];
                                        break
                                    }
                            } else if (p && (i = (e[T] || (e[T] = {}))[f]) && i[0] === k) o = i[1];
                            else
                                for (;
                                    (a = ++s && a && a[c] || (o = s = 0) || l.pop()) && ((_ ? a.nodeName.toLowerCase() !== u : 1 !== a.nodeType) || !++o || (p && ((a[T] || (a[T] = {}))[f] = [k, o]), a !== e)););
                            return (o -= m) === h || o % h == 0 && 0 <= o / h
                        }
                    }
                },
                PSEUDO: function(e, a) {
                    var t, o = b.pseudos[e] || b.setFilters[e.toLowerCase()] || te.error("unsupported pseudo: " + e);
                    return o[T] ? o(a) : 1 < o.length ? (t = [e, e, "", a], b.setFilters.hasOwnProperty(e.toLowerCase()) ? ie(function(e, t) {
                        for (var n, i = o(e, a), r = i.length; r--;) e[n = M.call(e, i[r])] = !(t[n] = i[r])
                    }) : function(e) {
                        return o(e, 0, t)
                    }) : o
                }
            },
            pseudos: {
                not: ie(function(e) {
                    var i = [],
                        r = [],
                        s = m(e.replace(B, "$1"));
                    return s[T] ? ie(function(e, t, n, i) {
                        for (var r, a = s(e, null, i, []), o = e.length; o--;)(r = a[o]) && (e[o] = !(t[o] = r))
                    }) : function(e, t, n) {
                        return i[0] = e, s(i, null, n, r), !r.pop()
                    }
                }),
                has: ie(function(t) {
                    return function(e) {
                        return 0 < te(t, e).length
                    }
                }),
                contains: ie(function(t) {
                    return function(e) {
                        return -1 < (e.textContent || e.innerText || a(e)).indexOf(t)
                    }
                }),
                lang: ie(function(n) {
                    return X.test(n || "") || te.error("unsupported lang: " + n), n = n.replace(Z, ee).toLowerCase(),
                        function(e) {
                            var t;
                            do {
                                if (t = v ? e.lang : e.getAttribute("xml:lang") || e.getAttribute("lang")) return (t = t.toLowerCase()) === n || 0 === t.indexOf(n + "-")
                            } while ((e = e.parentNode) && 1 === e.nodeType);
                            return !1
                        }
                }),
                target: function(e) {
                    var t = n.location && n.location.hash;
                    return t && t.slice(1) === e.id
                },
                root: function(e) {
                    return e === r
                },
                focus: function(e) {
                    return e === w.activeElement && (!w.hasFocus || w.hasFocus()) && !!(e.type || e.href || ~e.tabIndex)
                },
                enabled: function(e) {
                    return !1 === e.disabled
                },
                disabled: function(e) {
                    return !0 === e.disabled
                },
                checked: function(e) {
                    var t = e.nodeName.toLowerCase();
                    return "input" === t && !!e.checked || "option" === t && !!e.selected
                },
                selected: function(e) {
                    return e.parentNode && e.parentNode.selectedIndex, !0 === e.selected
                },
                empty: function(e) {
                    for (e = e.firstChild; e; e = e.nextSibling)
                        if (e.nodeType < 6) return !1;
                    return !0
                },
                parent: function(e) {
                    return !b.pseudos.empty(e)
                },
                header: function(e) {
                    return U.test(e.nodeName)
                },
                input: function(e) {
                    return Y.test(e.nodeName)
                },
                button: function(e) {
                    var t = e.nodeName.toLowerCase();
                    return "input" === t && "button" === e.type || "button" === t
                },
                text: function(e) {
                    var t;
                    return "input" === e.nodeName.toLowerCase() && "text" === e.type && (null == (t = e.getAttribute("type")) || "text" === t.toLowerCase())
                },
                first: ce(function() {
                    return [0]
                }),
                last: ce(function(e, t) {
                    return [t - 1]
                }),
                eq: ce(function(e, t, n) {
                    return [n < 0 ? n + t : n]
                }),
                even: ce(function(e, t) {
                    for (var n = 0; n < t; n += 2) e.push(n);
                    return e
                }),
                odd: ce(function(e, t) {
                    for (var n = 1; n < t; n += 2) e.push(n);
                    return e
                }),
                lt: ce(function(e, t, n) {
                    for (var i = n < 0 ? n + t : n; 0 <= --i;) e.push(i);
                    return e
                }),
                gt: ce(function(e, t, n) {
                    for (var i = n < 0 ? n + t : n; ++i < t;) e.push(i);
                    return e
                })
            }
        }).pseudos.nth = b.pseudos.eq, {
            radio: !0,
            checkbox: !0,
            file: !0,
            password: !0,
            image: !0
        }) b.pseudos[e] = se(e);
        for (e in {
            submit: !0,
            reset: !0
        }) b.pseudos[e] = le(e);

        function ue() {}

        function pe(e, t) {
            var n, i, r, a, o, s, l, c = p[e + " "];
            if (c) return t ? 0 : c.slice(0);
            for (o = e, s = [], l = b.preFilter; o;) {
                for (a in n && !(i = F.exec(o)) || (i && (o = o.slice(i[0].length) || o), s.push(r = [])), n = !1, (i = z.exec(o)) && (n = i.shift(), r.push({
                    value: n,
                    type: i[0].replace(B, " ")
                }), o = o.slice(n.length)), b.filter) !(i = V[a].exec(o)) || l[a] && !(i = l[a](i)) || (n = i.shift(), r.push({
                    value: n,
                    type: a,
                    matches: i
                }), o = o.slice(n.length));
                if (!n) break
            }
            return t ? o.length : o ? te.error(e) : p(e, s).slice(0)
        }

        function fe(e) {
            for (var t = 0, n = e.length, i = ""; t < n; t++) i += e[t].value;
            return i
        }

        function he(o, e, t) {
            var s = e.dir,
                l = t && "parentNode" === s,
                c = u++;
            return e.first ? function(e, t, n) {
                for (; e = e[s];)
                    if (1 === e.nodeType || l) return o(e, t, n)
            } : function(e, t, n) {
                var i, r, a = [k, c];
                if (n) {
                    for (; e = e[s];)
                        if ((1 === e.nodeType || l) && o(e, t, n)) return !0
                } else
                    for (; e = e[s];)
                        if (1 === e.nodeType || l) {
                            if ((i = (r = e[T] || (e[T] = {}))[s]) && i[0] === k && i[1] === c) return a[2] = i[2];
                            if ((r[s] = a)[2] = o(e, t, n)) return !0
                        }
            }
        }

        function me(r) {
            return 1 < r.length ? function(e, t, n) {
                for (var i = r.length; i--;)
                    if (!r[i](e, t, n)) return !1;
                return !0
            } : r[0]
        }

        function ge(e, t, n, i, r) {
            for (var a, o = [], s = 0, l = e.length, c = null != t; s < l; s++) !(a = e[s]) || n && !n(a, i, r) || (o.push(a), c && t.push(s));
            return o
        }

        function ve(f, h, m, g, v, e) {
            return g && !g[T] && (g = ve(g)), v && !v[T] && (v = ve(v, e)), ie(function(e, t, n, i) {
                var r, a, o, s = [],
                    l = [],
                    c = t.length,
                    d = e || function(e, t, n) {
                        for (var i = 0, r = t.length; i < r; i++) te(e, t[i], n);
                        return n
                    }(h || "*", n.nodeType ? [n] : n, []),
                    u = !f || !e && h ? d : ge(d, s, f, n, i),
                    p = m ? v || (e ? f : c || g) ? [] : t : u;
                if (m && m(u, p, n, i), g)
                    for (r = ge(p, l), g(r, [], n, i), a = r.length; a--;)(o = r[a]) && (p[l[a]] = !(u[l[a]] = o));
                if (e) {
                    if (v || f) {
                        if (v) {
                            for (r = [], a = p.length; a--;)(o = p[a]) && r.push(u[a] = o);
                            v(null, p = [], r, i)
                        }
                        for (a = p.length; a--;)(o = p[a]) && -1 < (r = v ? M.call(e, o) : s[a]) && (e[r] = !(t[r] = o))
                    }
                } else p = ge(p === t ? p.splice(c, p.length) : p), v ? v(null, t, p, i) : D.apply(t, p)
            })
        }

        function _e(e) {
            for (var i, t, n, r = e.length, a = b.relative[e[0].type], o = a || b.relative[" "], s = a ? 1 : 0, l = he(function(e) {
                return e === i
            }, o, !0), c = he(function(e) {
                return -1 < M.call(i, e)
            }, o, !0), d = [function(e, t, n) {
                return !a && (n || t !== x) || ((i = t).nodeType ? l : c)(e, t, n)
            }]; s < r; s++)
                if (t = b.relative[e[s].type]) d = [he(me(d), t)];
                else {
                    if ((t = b.filter[e[s].type].apply(null, e[s].matches))[T]) {
                        for (n = ++s; n < r && !b.relative[e[n].type]; n++);
                        return ve(1 < s && me(d), 1 < s && fe(e.slice(0, s - 1).concat({
                            value: " " === e[s - 2].type ? "*" : ""
                        })).replace(B, "$1"), t, s < n && _e(e.slice(s, n)), n < r && _e(e = e.slice(n)), n < r && fe(e))
                    }
                    d.push(t)
                }
            return me(d)
        }

        function ye(g, v) {
            function e(e, t, n, i, r) {
                var a, o, s, l = 0,
                    c = "0",
                    d = e && [],
                    u = [],
                    p = x,
                    f = e || y && b.find.TAG("*", r),
                    h = k += null == p ? 1 : Math.random() || .1,
                    m = f.length;
                for (r && (x = t !== w && t); c !== m && null != (a = f[c]); c++) {
                    if (y && a) {
                        for (o = 0; s = g[o++];)
                            if (s(a, t, n)) {
                                i.push(a);
                                break
                            }
                        r && (k = h)
                    }
                    _ && ((a = !s && a) && l--, e && d.push(a))
                }
                if (l += c, _ && c !== l) {
                    for (o = 0; s = v[o++];) s(d, u, t, n);
                    if (e) {
                        if (0 < l)
                            for (; c--;) d[c] || u[c] || (u[c] = $.call(i));
                        u = ge(u)
                    }
                    D.apply(i, u), r && !e && 0 < u.length && 1 < l + v.length && te.uniqueSort(i)
                }
                return r && (k = h, x = p), d
            }
            var _ = 0 < v.length,
                y = 0 < g.length;
            return _ ? ie(e) : e
        }
        return ue.prototype = b.filters = b.pseudos, b.setFilters = new ue, m = te.compile = function(e, t) {
            var n, i = [],
                r = [],
                a = f[e + " "];
            if (!a) {
                for (n = (t = t || pe(e)).length; n--;)(a = _e(t[n]))[T] ? i.push(a) : r.push(a);
                a = f(e, ye(r, i))
            }
            return a
        }, h.sortStable = T.split("").sort(E).join("") === T, h.detectDuplicates = !!d, g(), h.sortDetached = re(function(e) {
            return 1 & e.compareDocumentPosition(w.createElement("div"))
        }), re(function(e) {
            return e.innerHTML = "<a href='#'></a>", "#" === e.firstChild.getAttribute("href")
        }) || ae("type|href|height|width", function(e, t, n) {
            return n ? void 0 : e.getAttribute(t, "type" === t.toLowerCase() ? 1 : 2)
        }), h.attributes && re(function(e) {
            return e.innerHTML = "<input/>", e.firstChild.setAttribute("value", ""), "" === e.firstChild.getAttribute("value")
        }) || ae("value", function(e, t, n) {
            return n || "input" !== e.nodeName.toLowerCase() ? void 0 : e.defaultValue
        }), re(function(e) {
            return null == e.getAttribute("disabled")
        }) || ae(L, function(e, t, n) {
            var i;
            return n ? void 0 : !0 === e[t] ? t.toLowerCase() : (i = e.getAttributeNode(t)) && i.specified ? i.value : null
        }), te
    }(h);
    T.find = _, T.expr = _.selectors, T.expr[":"] = T.expr.pseudos, T.unique = _.uniqueSort, T.text = _.getText, T.isXMLDoc = _.isXML, T.contains = _.contains;
    var y = T.expr.match.needsContext,
        b = /^<(\w+)\s*\/?>(?:<\/\1>|)$/,
        x = /^.[^:#\[\.,]*$/;

    function w(e, n, i) {
        if (T.isFunction(n)) return T.grep(e, function(e, t) {
            return !!n.call(e, t, e) !== i
        });
        if (n.nodeType) return T.grep(e, function(e) {
            return e === n !== i
        });
        if ("string" == typeof n) {
            if (x.test(n)) return T.filter(n, e, i);
            n = T.filter(n, e)
        }
        return T.grep(e, function(e) {
            return 0 <= T.inArray(e, n) !== i
        })
    }
    T.filter = function(e, t, n) {
        var i = t[0];
        return n && (e = ":not(" + e + ")"), 1 === t.length && 1 === i.nodeType ? T.find.matchesSelector(i, e) ? [i] : [] : T.find.matches(e, T.grep(t, function(e) {
            return 1 === e.nodeType
        }))
    }, T.fn.extend({
        find: function(e) {
            var t, n = [],
                i = this,
                r = i.length;
            if ("string" != typeof e) return this.pushStack(T(e).filter(function() {
                for (t = 0; t < r; t++)
                    if (T.contains(i[t], this)) return !0
            }));
            for (t = 0; t < r; t++) T.find(e, i[t], n);
            return (n = this.pushStack(1 < r ? T.unique(n) : n)).selector = this.selector ? this.selector + " " + e : e, n
        },
        filter: function(e) {
            return this.pushStack(w(this, e || [], !1))
        },
        not: function(e) {
            return this.pushStack(w(this, e || [], !0))
        },
        is: function(e) {
            return !!w(this, "string" == typeof e && y.test(e) ? T(e) : e || [], !1).length
        }
    });
    var C, k = h.document,
        E = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/;
    (T.fn.init = function(e, t) {
        var n, i;
        if (!e) return this;
        if ("string" != typeof e) return e.nodeType ? (this.context = this[0] = e, this.length = 1, this) : T.isFunction(e) ? void 0 !== C.ready ? C.ready(e) : e(T) : (void 0 !== e.selector && (this.selector = e.selector, this.context = e.context), T.makeArray(e, this));
        if (!(n = "<" === e.charAt(0) && ">" === e.charAt(e.length - 1) && 3 <= e.length ? [null, e, null] : E.exec(e)) || !n[1] && t) return !t || t.jquery ? (t || C).find(e) : this.constructor(t).find(e);
        if (n[1]) {
            if (t = t instanceof T ? t[0] : t, T.merge(this, T.parseHTML(n[1], t && t.nodeType ? t.ownerDocument || t : k, !0)), b.test(n[1]) && T.isPlainObject(t))
                for (n in t) T.isFunction(this[n]) ? this[n](t[n]) : this.attr(n, t[n]);
            return this
        }
        if ((i = k.getElementById(n[2])) && i.parentNode) {
            if (i.id !== n[2]) return C.find(e);
            this.length = 1, this[0] = i
        }
        return this.context = k, this.selector = e, this
    }).prototype = T.fn, C = T(k);
    var N = /^(?:parents|prev(?:Until|All))/,
        S = {
            children: !0,
            contents: !0,
            next: !0,
            prev: !0
        };

    function $(e, t) {
        for (;
            (e = e[t]) && 1 !== e.nodeType;);
        return e
    }
    T.extend({
        dir: function(e, t, n) {
            for (var i = [], r = e[t]; r && 9 !== r.nodeType && (void 0 === n || 1 !== r.nodeType || !T(r).is(n));) 1 === r.nodeType && i.push(r), r = r[t];
            return i
        },
        sibling: function(e, t) {
            for (var n = []; e; e = e.nextSibling) 1 === e.nodeType && e !== t && n.push(e);
            return n
        }
    }), T.fn.extend({
        has: function(e) {
            var t, n = T(e, this),
                i = n.length;
            return this.filter(function() {
                for (t = 0; t < i; t++)
                    if (T.contains(this, n[t])) return !0
            })
        },
        closest: function(e, t) {
            for (var n, i = 0, r = this.length, a = [], o = y.test(e) || "string" != typeof e ? T(e, t || this.context) : 0; i < r; i++)
                for (n = this[i]; n && n !== t; n = n.parentNode)
                    if (n.nodeType < 11 && (o ? -1 < o.index(n) : 1 === n.nodeType && T.find.matchesSelector(n, e))) {
                        a.push(n);
                        break
                    }
            return this.pushStack(1 < a.length ? T.unique(a) : a)
        },
        index: function(e) {
            return e ? "string" == typeof e ? T.inArray(this[0], T(e)) : T.inArray(e.jquery ? e[0] : e, this) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1
        },
        add: function(e, t) {
            return this.pushStack(T.unique(T.merge(this.get(), T(e, t))))
        },
        addBack: function(e) {
            return this.add(null == e ? this.prevObject : this.prevObject.filter(e))
        }
    }), T.each({
        parent: function(e) {
            var t = e.parentNode;
            return t && 11 !== t.nodeType ? t : null
        },
        parents: function(e) {
            return T.dir(e, "parentNode")
        },
        parentsUntil: function(e, t, n) {
            return T.dir(e, "parentNode", n)
        },
        next: function(e) {
            return $(e, "nextSibling")
        },
        prev: function(e) {
            return $(e, "previousSibling")
        },
        nextAll: function(e) {
            return T.dir(e, "nextSibling")
        },
        prevAll: function(e) {
            return T.dir(e, "previousSibling")
        },
        nextUntil: function(e, t, n) {
            return T.dir(e, "nextSibling", n)
        },
        prevUntil: function(e, t, n) {
            return T.dir(e, "previousSibling", n)
        },
        siblings: function(e) {
            return T.sibling((e.parentNode || {}).firstChild, e)
        },
        children: function(e) {
            return T.sibling(e.firstChild)
        },
        contents: function(e) {
            return T.nodeName(e, "iframe") ? e.contentDocument || e.contentWindow.document : T.merge([], e.childNodes)
        }
    }, function(i, r) {
        T.fn[i] = function(e, t) {
            var n = T.map(this, r, e);
            return "Until" !== i.slice(-5) && (t = e), t && "string" == typeof t && (n = T.filter(t, n)), 1 < this.length && (S[i] || (n = T.unique(n)), N.test(i) && (n = n.reverse())), this.pushStack(n)
        }
    });
    var A, D = /\S+/g,
        j = {};

    function M() {
        k.addEventListener ? (k.removeEventListener("DOMContentLoaded", L, !1), h.removeEventListener("load", L, !1)) : (k.detachEvent("onreadystatechange", L), h.detachEvent("onload", L))
    }

    function L() {
        !k.addEventListener && "load" !== event.type && "complete" !== k.readyState || (M(), T.ready())
    }
    T.Callbacks = function(r) {
        var e, n;
        r = "string" == typeof r ? j[r] || (n = j[e = r] = {}, T.each(e.match(D) || [], function(e, t) {
            n[t] = !0
        }), n) : T.extend({}, r);
        var i, t, a, o, s, l, c = [],
            d = !r.once && [],
            u = function(e) {
                for (t = r.memory && e, a = !0, s = l || 0, l = 0, o = c.length, i = !0; c && s < o; s++)
                    if (!1 === c[s].apply(e[0], e[1]) && r.stopOnFalse) {
                        t = !1;
                        break
                    }
                i = !1, c && (d ? d.length && u(d.shift()) : t ? c = [] : p.disable())
            },
            p = {
                add: function() {
                    if (c) {
                        var e = c.length;
                        ! function i(e) {
                            T.each(e, function(e, t) {
                                var n = T.type(t);
                                "function" === n ? r.unique && p.has(t) || c.push(t) : t && t.length && "string" !== n && i(t)
                            })
                        }(arguments), i ? o = c.length : t && (l = e, u(t))
                    }
                    return this
                },
                remove: function() {
                    return c && T.each(arguments, function(e, t) {
                        for (var n; - 1 < (n = T.inArray(t, c, n));) c.splice(n, 1), i && (n <= o && o--, n <= s && s--)
                    }), this
                },
                has: function(e) {
                    return e ? -1 < T.inArray(e, c) : !(!c || !c.length)
                },
                empty: function() {
                    return c = [], o = 0, this
                },
                disable: function() {
                    return c = d = t = void 0, this
                },
                disabled: function() {
                    return !c
                },
                lock: function() {
                    return d = void 0, t || p.disable(), this
                },
                locked: function() {
                    return !d
                },
                fireWith: function(e, t) {
                    return !c || a && !d || (t = [e, (t = t || []).slice ? t.slice() : t], i ? d.push(t) : u(t)), this
                },
                fire: function() {
                    return p.fireWith(this, arguments), this
                },
                fired: function() {
                    return !!a
                }
            };
        return p
    }, T.extend({
        Deferred: function(e) {
            var a = [
                    ["resolve", "done", T.Callbacks("once memory"), "resolved"],
                    ["reject", "fail", T.Callbacks("once memory"), "rejected"],
                    ["notify", "progress", T.Callbacks("memory")]
                ],
                r = "pending",
                o = {
                    state: function() {
                        return r
                    },
                    always: function() {
                        return s.done(arguments).fail(arguments), this
                    },
                    then: function() {
                        var r = arguments;
                        return T.Deferred(function(i) {
                            T.each(a, function(e, t) {
                                var n = T.isFunction(r[e]) && r[e];
                                s[t[1]](function() {
                                    var e = n && n.apply(this, arguments);
                                    e && T.isFunction(e.promise) ? e.promise().done(i.resolve).fail(i.reject).progress(i.notify) : i[t[0] + "With"](this === o ? i.promise() : this, n ? [e] : arguments)
                                })
                            }), r = null
                        }).promise()
                    },
                    promise: function(e) {
                        return null != e ? T.extend(e, o) : o
                    }
                },
                s = {};
            return o.pipe = o.then, T.each(a, function(e, t) {
                var n = t[2],
                    i = t[3];
                o[t[1]] = n.add, i && n.add(function() {
                    r = i
                }, a[1 ^ e][2].disable, a[2][2].lock), s[t[0]] = function() {
                    return s[t[0] + "With"](this === s ? o : this, arguments), this
                }, s[t[0] + "With"] = n.fireWith
            }), o.promise(s), e && e.call(s, s), s
        },
        when: function(e) {
            function t(t, n, i) {
                return function(e) {
                    n[t] = this, i[t] = 1 < arguments.length ? d.call(arguments) : e, i === r ? c.notifyWith(n, i) : --l || c.resolveWith(n, i)
                }
            }
            var r, n, i, a = 0,
                o = d.call(arguments),
                s = o.length,
                l = 1 !== s || e && T.isFunction(e.promise) ? s : 0,
                c = 1 === l ? e : T.Deferred();
            if (1 < s)
                for (r = new Array(s), n = new Array(s), i = new Array(s); a < s; a++) o[a] && T.isFunction(o[a].promise) ? o[a].promise().done(t(a, i, o)).fail(c.reject).progress(t(a, n, r)) : --l;
            return l || c.resolveWith(i, o), c.promise()
        }
    }), T.fn.ready = function(e) {
        return T.ready.promise().done(e), this
    }, T.extend({
        isReady: !1,
        readyWait: 1,
        holdReady: function(e) {
            e ? T.readyWait++ : T.ready(!0)
        },
        ready: function(e) {
            if (!0 === e ? !--T.readyWait : !T.isReady) {
                if (!k.body) return setTimeout(T.ready);
                (T.isReady = !0) !== e && 0 < --T.readyWait || (A.resolveWith(k, [T]), T.fn.trigger && T(k).trigger("ready").off("ready"))
            }
        }
    }), T.ready.promise = function(e) {
        if (!A)
            if (A = T.Deferred(), "complete" === k.readyState) setTimeout(T.ready);
            else if (k.addEventListener) k.addEventListener("DOMContentLoaded", L, !1), h.addEventListener("load", L, !1);
            else {
                k.attachEvent("onreadystatechange", L), h.attachEvent("onload", L);
                var n = !1;
                try {
                    n = null == h.frameElement && k.documentElement
                } catch (e) {}
                n && n.doScroll && ! function t() {
                    if (!T.isReady) {
                        try {
                            n.doScroll("left")
                        } catch (e) {
                            return setTimeout(t, 50)
                        }
                        M(), T.ready()
                    }
                }()
            }
        return A.promise(e)
    };
    var H, q = "undefined";
    for (H in T(v)) break;
    v.ownLast = "0" !== H, v.inlineBlockNeedsLayout = !1, T(function() {
        var e, t, n = k.getElementsByTagName("body")[0];
        n && ((e = k.createElement("div")).style.cssText = "border:0;width:0;height:0;position:absolute;top:0;left:-9999px;margin-top:1px", t = k.createElement("div"), n.appendChild(e).appendChild(t), typeof t.style.zoom !== q && (t.style.cssText = "border:0;margin:0;width:1px;padding:1px;display:inline;zoom:1", (v.inlineBlockNeedsLayout = 3 === t.offsetWidth) && (n.style.zoom = 1)), n.removeChild(e), e = t = null)
    }),
        function() {
            var e = k.createElement("div");
            if (null == v.deleteExpando) {
                v.deleteExpando = !0;
                try {
                    delete e.test
                } catch (e) {
                    v.deleteExpando = !1
                }
            }
            e = null
        }(), T.acceptData = function(e) {
        var t = T.noData[(e.nodeName + " ").toLowerCase()],
            n = +e.nodeType || 1;
        return (1 === n || 9 === n) && (!t || !0 !== t && e.getAttribute("classid") === t)
    };
    var W = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
        P = /([A-Z])/g;

    function O(e, t, n) {
        if (void 0 === n && 1 === e.nodeType) {
            var i = "data-" + t.replace(P, "-$1").toLowerCase();
            if ("string" == typeof(n = e.getAttribute(i))) {
                try {
                    n = "true" === n || "false" !== n && ("null" === n ? null : +n + "" === n ? +n : W.test(n) ? T.parseJSON(n) : n)
                } catch (e) {}
                T.data(e, t, n)
            } else n = void 0
        }
        return n
    }

    function B(e) {
        var t;
        for (t in e)
            if (("data" !== t || !T.isEmptyObject(e[t])) && "toJSON" !== t) return;
        return 1
    }

    function F(e, t, n, i) {
        if (T.acceptData(e)) {
            var r, a, o = T.expando,
                s = e.nodeType,
                l = s ? T.cache : e,
                c = s ? e[o] : e[o] && o;
            if (c && l[c] && (i || l[c].data) || void 0 !== n || "string" != typeof t) return l[c = c || (s ? e[o] = u.pop() || T.guid++ : o)] || (l[c] = s ? {} : {
                toJSON: T.noop
            }), "object" != typeof t && "function" != typeof t || (i ? l[c] = T.extend(l[c], t) : l[c].data = T.extend(l[c].data, t)), a = l[c], i || (a.data || (a.data = {}), a = a.data), void 0 !== n && (a[T.camelCase(t)] = n), "string" == typeof t ? null == (r = a[t]) && (r = a[T.camelCase(t)]) : r = a, r
        }
    }

    function z(e, t, n) {
        if (T.acceptData(e)) {
            var i, r, a = e.nodeType,
                o = a ? T.cache : e,
                s = a ? e[T.expando] : T.expando;
            if (o[s]) {
                if (t && (i = n ? o[s] : o[s].data)) {
                    r = (t = T.isArray(t) ? t.concat(T.map(t, T.camelCase)) : t in i ? [t] : (t = T.camelCase(t)) in i ? [t] : t.split(" ")).length;
                    for (; r--;) delete i[t[r]];
                    if (n ? !B(i) : !T.isEmptyObject(i)) return
                }(n || (delete o[s].data, B(o[s]))) && (a ? T.cleanData([e], !0) : v.deleteExpando || o != o.window ? delete o[s] : o[s] = null)
            }
        }
    }
    T.extend({
        cache: {},
        noData: {
            "applet ": !0,
            "embed ": !0,
            "object ": "clsid:D27CDB6E-AE6D-11cf-96B8-444553540000"
        },
        hasData: function(e) {
            return !!(e = e.nodeType ? T.cache[e[T.expando]] : e[T.expando]) && !B(e)
        },
        data: function(e, t, n) {
            return F(e, t, n)
        },
        removeData: function(e, t) {
            return z(e, t)
        },
        _data: function(e, t, n) {
            return F(e, t, n, !0)
        },
        _removeData: function(e, t) {
            return z(e, t, !0)
        }
    }), T.fn.extend({
        data: function(e, t) {
            var n, i, r, a = this[0],
                o = a && a.attributes;
            if (void 0 !== e) return "object" == typeof e ? this.each(function() {
                T.data(this, e)
            }) : 1 < arguments.length ? this.each(function() {
                T.data(this, e, t)
            }) : a ? O(a, e, T.data(a, e)) : void 0;
            if (this.length && (r = T.data(a), 1 === a.nodeType && !T._data(a, "parsedAttrs"))) {
                for (n = o.length; n--;) 0 === (i = o[n].name).indexOf("data-") && O(a, i = T.camelCase(i.slice(5)), r[i]);
                T._data(a, "parsedAttrs", !0)
            }
            return r
        },
        removeData: function(e) {
            return this.each(function() {
                T.removeData(this, e)
            })
        }
    }), T.extend({
        queue: function(e, t, n) {
            var i;
            return e ? (t = (t || "fx") + "queue", i = T._data(e, t), n && (!i || T.isArray(n) ? i = T._data(e, t, T.makeArray(n)) : i.push(n)), i || []) : void 0
        },
        dequeue: function(e, t) {
            t = t || "fx";
            var n = T.queue(e, t),
                i = n.length,
                r = n.shift(),
                a = T._queueHooks(e, t);
            "inprogress" === r && (r = n.shift(), i--), r && ("fx" === t && n.unshift("inprogress"), delete a.stop, r.call(e, function() {
                T.dequeue(e, t)
            }, a)), !i && a && a.empty.fire()
        },
        _queueHooks: function(e, t) {
            var n = t + "queueHooks";
            return T._data(e, n) || T._data(e, n, {
                empty: T.Callbacks("once memory").add(function() {
                    T._removeData(e, t + "queue"), T._removeData(e, n)
                })
            })
        }
    }), T.fn.extend({
        queue: function(t, n) {
            var e = 2;
            return "string" != typeof t && (n = t, t = "fx", e--), arguments.length < e ? T.queue(this[0], t) : void 0 === n ? this : this.each(function() {
                var e = T.queue(this, t, n);
                T._queueHooks(this, t), "fx" === t && "inprogress" !== e[0] && T.dequeue(this, t)
            })
        },
        dequeue: function(e) {
            return this.each(function() {
                T.dequeue(this, e)
            })
        },
        clearQueue: function(e) {
            return this.queue(e || "fx", [])
        },
        promise: function(e, t) {
            function n() {
                --r || a.resolveWith(o, [o])
            }
            var i, r = 1,
                a = T.Deferred(),
                o = this,
                s = this.length;
            for ("string" != typeof e && (t = e, e = void 0), e = e || "fx"; s--;)(i = T._data(o[s], e + "queueHooks")) && i.empty && (r++, i.empty.add(n));
            return n(), a.promise(t)
        }
    });

    function I(e, t) {
        return e = t || e, "none" === T.css(e, "display") || !T.contains(e.ownerDocument, e)
    }
    var R = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
        X = ["Top", "Right", "Bottom", "Left"],
        V = T.access = function(e, t, n, i, r, a, o) {
            var s = 0,
                l = e.length,
                c = null == n;
            if ("object" === T.type(n))
                for (s in r = !0, n) T.access(e, t, s, n[s], !0, a, o);
            else if (void 0 !== i && (r = !0, T.isFunction(i) || (o = !0), c && (t = o ? (t.call(e, i), null) : (c = t, function(e, t, n) {
                return c.call(T(e), n)
            })), t))
                for (; s < l; s++) t(e[s], n, o ? i : i.call(e[s], s, t(e[s], n)));
            return r ? e : c ? t.call(e) : l ? t(e[0], n) : a
        },
        Y = /^(?:checkbox|radio)$/i;
    ! function() {
        var e = k.createDocumentFragment(),
            t = k.createElement("div"),
            n = k.createElement("input");
        if (t.setAttribute("className", "t"), t.innerHTML = "  <link/><table></table><a href='/a'>a</a>", v.leadingWhitespace = 3 === t.firstChild.nodeType, v.tbody = !t.getElementsByTagName("tbody").length, v.htmlSerialize = !!t.getElementsByTagName("link").length, v.html5Clone = "<:nav></:nav>" !== k.createElement("nav").cloneNode(!0).outerHTML, n.type = "checkbox", n.checked = !0, e.appendChild(n), v.appendChecked = n.checked, t.innerHTML = "<textarea>x</textarea>", v.noCloneChecked = !!t.cloneNode(!0).lastChild.defaultValue, e.appendChild(t), t.innerHTML = "<input type='radio' checked='checked' name='t'/>", v.checkClone = t.cloneNode(!0).cloneNode(!0).lastChild.checked, v.noCloneEvent = !0, t.attachEvent && (t.attachEvent("onclick", function() {
            v.noCloneEvent = !1
        }), t.cloneNode(!0).click()), null == v.deleteExpando) {
            v.deleteExpando = !0;
            try {
                delete t.test
            } catch (e) {
                v.deleteExpando = !1
            }
        }
        e = t = n = null
    }(),
        function() {
            var e, t, n = k.createElement("div");
            for (e in {
                submit: !0,
                change: !0,
                focusin: !0
            }) t = "on" + e, (v[e + "Bubbles"] = t in h) || (n.setAttribute(t, "t"), v[e + "Bubbles"] = !1 === n.attributes[t].expando);
            n = null
        }();
    var U = /^(?:input|select|textarea)$/i,
        G = /^key/,
        Q = /^(?:mouse|contextmenu)|click/,
        J = /^(?:focusinfocus|focusoutblur)$/,
        K = /^([^.]*)(?:\.(.+)|)$/;

    function Z() {
        return !0
    }

    function ee() {
        return !1
    }

    function te() {
        try {
            return k.activeElement
        } catch (e) {}
    }

    function ne(e) {
        var t = ie.split("|"),
            n = e.createDocumentFragment();
        if (n.createElement)
            for (; t.length;) n.createElement(t.pop());
        return n
    }
    T.event = {
        global: {},
        add: function(e, t, n, i, r) {
            var a, o, s, l, c, d, u, p, f, h, m, g = T._data(e);
            if (g) {
                for (n.handler && (n = (l = n).handler, r = l.selector), n.guid || (n.guid = T.guid++), (o = g.events) || (o = g.events = {}), (d = g.handle) || ((d = g.handle = function(e) {
                    return typeof T === q || e && T.event.triggered === e.type ? void 0 : T.event.dispatch.apply(d.elem, arguments)
                }).elem = e), s = (t = (t || "").match(D) || [""]).length; s--;) f = m = (a = K.exec(t[s]) || [])[1], h = (a[2] || "").split(".").sort(), f && (c = T.event.special[f] || {}, f = (r ? c.delegateType : c.bindType) || f, c = T.event.special[f] || {}, u = T.extend({
                    type: f,
                    origType: m,
                    data: i,
                    handler: n,
                    guid: n.guid,
                    selector: r,
                    needsContext: r && T.expr.match.needsContext.test(r),
                    namespace: h.join(".")
                }, l), (p = o[f]) || ((p = o[f] = []).delegateCount = 0, c.setup && !1 !== c.setup.call(e, i, h, d) || (e.addEventListener ? e.addEventListener(f, d, !1) : e.attachEvent && e.attachEvent("on" + f, d))), c.add && (c.add.call(e, u), u.handler.guid || (u.handler.guid = n.guid)), r ? p.splice(p.delegateCount++, 0, u) : p.push(u), T.event.global[f] = !0);
                e = null
            }
        },
        remove: function(e, t, n, i, r) {
            var a, o, s, l, c, d, u, p, f, h, m, g = T.hasData(e) && T._data(e);
            if (g && (d = g.events)) {
                for (c = (t = (t || "").match(D) || [""]).length; c--;)
                    if (f = m = (s = K.exec(t[c]) || [])[1], h = (s[2] || "").split(".").sort(), f) {
                        for (u = T.event.special[f] || {}, p = d[f = (i ? u.delegateType : u.bindType) || f] || [], s = s[2] && new RegExp("(^|\\.)" + h.join("\\.(?:.*\\.|)") + "(\\.|$)"), l = a = p.length; a--;) o = p[a], !r && m !== o.origType || n && n.guid !== o.guid || s && !s.test(o.namespace) || i && i !== o.selector && ("**" !== i || !o.selector) || (p.splice(a, 1), o.selector && p.delegateCount--, u.remove && u.remove.call(e, o));
                        l && !p.length && (u.teardown && !1 !== u.teardown.call(e, h, g.handle) || T.removeEvent(e, f, g.handle), delete d[f])
                    } else
                        for (f in d) T.event.remove(e, f + t[c], n, i, !0);
                T.isEmptyObject(d) && (delete g.handle, T._removeData(e, "events"))
            }
        },
        trigger: function(e, t, n, i) {
            var r, a, o, s, l, c, d, u = [n || k],
                p = g.call(e, "type") ? e.type : e,
                f = g.call(e, "namespace") ? e.namespace.split(".") : [];
            if (o = c = n = n || k, 3 !== n.nodeType && 8 !== n.nodeType && !J.test(p + T.event.triggered) && (0 <= p.indexOf(".") && (p = (f = p.split(".")).shift(), f.sort()), a = p.indexOf(":") < 0 && "on" + p, (e = e[T.expando] ? e : new T.Event(p, "object" == typeof e && e)).isTrigger = i ? 2 : 3, e.namespace = f.join("."), e.namespace_re = e.namespace ? new RegExp("(^|\\.)" + f.join("\\.(?:.*\\.|)") + "(\\.|$)") : null, e.result = void 0, e.target || (e.target = n), t = null == t ? [e] : T.makeArray(t, [e]), l = T.event.special[p] || {}, i || !l.trigger || !1 !== l.trigger.apply(n, t))) {
                if (!i && !l.noBubble && !T.isWindow(n)) {
                    for (s = l.delegateType || p, J.test(s + p) || (o = o.parentNode); o; o = o.parentNode) u.push(o), c = o;
                    c === (n.ownerDocument || k) && u.push(c.defaultView || c.parentWindow || h)
                }
                for (d = 0;
                     (o = u[d++]) && !e.isPropagationStopped();) e.type = 1 < d ? s : l.bindType || p, (r = (T._data(o, "events") || {})[e.type] && T._data(o, "handle")) && r.apply(o, t), (r = a && o[a]) && r.apply && T.acceptData(o) && (e.result = r.apply(o, t), !1 === e.result && e.preventDefault());
                if (e.type = p, !i && !e.isDefaultPrevented() && (!l._default || !1 === l._default.apply(u.pop(), t)) && T.acceptData(n) && a && n[p] && !T.isWindow(n)) {
                    (c = n[a]) && (n[a] = null), T.event.triggered = p;
                    try {
                        n[p]()
                    } catch (e) {}
                    T.event.triggered = void 0, c && (n[a] = c)
                }
                return e.result
            }
        },
        dispatch: function(e) {
            e = T.event.fix(e);
            var t, n, i, r, a, o = [],
                s = d.call(arguments),
                l = (T._data(this, "events") || {})[e.type] || [],
                c = T.event.special[e.type] || {};
            if ((s[0] = e).delegateTarget = this, !c.preDispatch || !1 !== c.preDispatch.call(this, e)) {
                for (o = T.event.handlers.call(this, e, l), t = 0;
                     (r = o[t++]) && !e.isPropagationStopped();)
                    for (e.currentTarget = r.elem, a = 0;
                         (i = r.handlers[a++]) && !e.isImmediatePropagationStopped();) e.namespace_re && !e.namespace_re.test(i.namespace) || (e.handleObj = i, e.data = i.data, void 0 !== (n = ((T.event.special[i.origType] || {}).handle || i.handler).apply(r.elem, s)) && !1 === (e.result = n) && (e.preventDefault(), e.stopPropagation()));
                return c.postDispatch && c.postDispatch.call(this, e), e.result
            }
        },
        handlers: function(e, t) {
            var n, i, r, a, o = [],
                s = t.delegateCount,
                l = e.target;
            if (s && l.nodeType && (!e.button || "click" !== e.type))
                for (; l != this; l = l.parentNode || this)
                    if (1 === l.nodeType && (!0 !== l.disabled || "click" !== e.type)) {
                        for (r = [], a = 0; a < s; a++) void 0 === r[n = (i = t[a]).selector + " "] && (r[n] = i.needsContext ? 0 <= T(n, this).index(l) : T.find(n, this, null, [l]).length), r[n] && r.push(i);
                        r.length && o.push({
                            elem: l,
                            handlers: r
                        })
                    }
            return s < t.length && o.push({
                elem: this,
                handlers: t.slice(s)
            }), o
        },
        fix: function(e) {
            if (e[T.expando]) return e;
            var t, n, i, r = e.type,
                a = e,
                o = this.fixHooks[r];
            for (o || (this.fixHooks[r] = o = Q.test(r) ? this.mouseHooks : G.test(r) ? this.keyHooks : {}), i = o.props ? this.props.concat(o.props) : this.props, e = new T.Event(a), t = i.length; t--;) e[n = i[t]] = a[n];
            return e.target || (e.target = a.srcElement || k), 3 === e.target.nodeType && (e.target = e.target.parentNode), e.metaKey = !!e.metaKey, o.filter ? o.filter(e, a) : e
        },
        props: "altKey bubbles cancelable ctrlKey currentTarget eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(" "),
        fixHooks: {},
        keyHooks: {
            props: "char charCode key keyCode".split(" "),
            filter: function(e, t) {
                return null == e.which && (e.which = null != t.charCode ? t.charCode : t.keyCode), e
            }
        },
        mouseHooks: {
            props: "button buttons clientX clientY fromElement offsetX offsetY pageX pageY screenX screenY toElement".split(" "),
            filter: function(e, t) {
                var n, i, r, a = t.button,
                    o = t.fromElement;
                return null == e.pageX && null != t.clientX && (r = (i = e.target.ownerDocument || k).documentElement, n = i.body, e.pageX = t.clientX + (r && r.scrollLeft || n && n.scrollLeft || 0) - (r && r.clientLeft || n && n.clientLeft || 0), e.pageY = t.clientY + (r && r.scrollTop || n && n.scrollTop || 0) - (r && r.clientTop || n && n.clientTop || 0)), !e.relatedTarget && o && (e.relatedTarget = o === e.target ? t.toElement : o), e.which || void 0 === a || (e.which = 1 & a ? 1 : 2 & a ? 3 : 4 & a ? 2 : 0), e
            }
        },
        special: {
            load: {
                noBubble: !0
            },
            focus: {
                trigger: function() {
                    if (this !== te() && this.focus) try {
                        return this.focus(), !1
                    } catch (e) {}
                },
                delegateType: "focusin"
            },
            blur: {
                trigger: function() {
                    return this === te() && this.blur ? (this.blur(), !1) : void 0
                },
                delegateType: "focusout"
            },
            click: {
                trigger: function() {
                    return T.nodeName(this, "input") && "checkbox" === this.type && this.click ? (this.click(), !1) : void 0
                },
                _default: function(e) {
                    return T.nodeName(e.target, "a")
                }
            },
            beforeunload: {
                postDispatch: function(e) {
                    void 0 !== e.result && (e.originalEvent.returnValue = e.result)
                }
            }
        },
        simulate: function(e, t, n, i) {
            var r = T.extend(new T.Event, n, {
                type: e,
                isSimulated: !0,
                originalEvent: {}
            });
            i ? T.event.trigger(r, null, t) : T.event.dispatch.call(t, r), r.isDefaultPrevented() && n.preventDefault()
        }
    }, T.removeEvent = k.removeEventListener ? function(e, t, n) {
        e.removeEventListener && e.removeEventListener(t, n, !1)
    } : function(e, t, n) {
        var i = "on" + t;
        e.detachEvent && (typeof e[i] === q && (e[i] = null), e.detachEvent(i, n))
    }, T.Event = function(e, t) {
        return this instanceof T.Event ? (e && e.type ? (this.originalEvent = e, this.type = e.type, this.isDefaultPrevented = e.defaultPrevented || void 0 === e.defaultPrevented && (!1 === e.returnValue || e.getPreventDefault && e.getPreventDefault()) ? Z : ee) : this.type = e, t && T.extend(this, t), this.timeStamp = e && e.timeStamp || T.now(), void(this[T.expando] = !0)) : new T.Event(e, t)
    }, T.Event.prototype = {
        isDefaultPrevented: ee,
        isPropagationStopped: ee,
        isImmediatePropagationStopped: ee,
        preventDefault: function() {
            var e = this.originalEvent;
            this.isDefaultPrevented = Z, e && (e.preventDefault ? e.preventDefault() : e.returnValue = !1)
        },
        stopPropagation: function() {
            var e = this.originalEvent;
            this.isPropagationStopped = Z, e && (e.stopPropagation && e.stopPropagation(), e.cancelBubble = !0)
        },
        stopImmediatePropagation: function() {
            this.isImmediatePropagationStopped = Z, this.stopPropagation()
        }
    }, T.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout"
    }, function(e, r) {
        T.event.special[e] = {
            delegateType: r,
            bindType: r,
            handle: function(e) {
                var t, n = e.relatedTarget,
                    i = e.handleObj;
                return n && (n === this || T.contains(this, n)) || (e.type = i.origType, t = i.handler.apply(this, arguments), e.type = r), t
            }
        }
    }), v.submitBubbles || (T.event.special.submit = {
        setup: function() {
            return !T.nodeName(this, "form") && void T.event.add(this, "click._submit keypress._submit", function(e) {
                var t = e.target,
                    n = T.nodeName(t, "input") || T.nodeName(t, "button") ? t.form : void 0;
                n && !T._data(n, "submitBubbles") && (T.event.add(n, "submit._submit", function(e) {
                    e._submit_bubble = !0
                }), T._data(n, "submitBubbles", !0))
            })
        },
        postDispatch: function(e) {
            e._submit_bubble && (delete e._submit_bubble, this.parentNode && !e.isTrigger && T.event.simulate("submit", this.parentNode, e, !0))
        },
        teardown: function() {
            return !T.nodeName(this, "form") && void T.event.remove(this, "._submit")
        }
    }), v.changeBubbles || (T.event.special.change = {
        setup: function() {
            return U.test(this.nodeName) ? ("checkbox" !== this.type && "radio" !== this.type || (T.event.add(this, "propertychange._change", function(e) {
                "checked" === e.originalEvent.propertyName && (this._just_changed = !0)
            }), T.event.add(this, "click._change", function(e) {
                this._just_changed && !e.isTrigger && (this._just_changed = !1), T.event.simulate("change", this, e, !0)
            })), !1) : void T.event.add(this, "beforeactivate._change", function(e) {
                var t = e.target;
                U.test(t.nodeName) && !T._data(t, "changeBubbles") && (T.event.add(t, "change._change", function(e) {
                    !this.parentNode || e.isSimulated || e.isTrigger || T.event.simulate("change", this.parentNode, e, !0)
                }), T._data(t, "changeBubbles", !0))
            })
        },
        handle: function(e) {
            var t = e.target;
            return this !== t || e.isSimulated || e.isTrigger || "radio" !== t.type && "checkbox" !== t.type ? e.handleObj.handler.apply(this, arguments) : void 0
        },
        teardown: function() {
            return T.event.remove(this, "._change"), !U.test(this.nodeName)
        }
    }), v.focusinBubbles || T.each({
        focus: "focusin",
        blur: "focusout"
    }, function(n, i) {
        function r(e) {
            T.event.simulate(i, e.target, T.event.fix(e), !0)
        }
        T.event.special[i] = {
            setup: function() {
                var e = this.ownerDocument || this,
                    t = T._data(e, i);
                t || e.addEventListener(n, r, !0), T._data(e, i, (t || 0) + 1)
            },
            teardown: function() {
                var e = this.ownerDocument || this,
                    t = T._data(e, i) - 1;
                t ? T._data(e, i, t) : (e.removeEventListener(n, r, !0), T._removeData(e, i))
            }
        }
    }), T.fn.extend({
        on: function(e, t, n, i, r) {
            var a, o;
            if ("object" == typeof e) {
                for (a in "string" != typeof t && (n = n || t, t = void 0), e) this.on(a, t, n, e[a], r);
                return this
            }
            if (null == n && null == i ? (i = t, n = t = void 0) : null == i && ("string" == typeof t ? (i = n, n = void 0) : (i = n, n = t, t = void 0)), !1 === i) i = ee;
            else if (!i) return this;
            return 1 === r && (o = i, (i = function(e) {
                return T().off(e), o.apply(this, arguments)
            }).guid = o.guid || (o.guid = T.guid++)), this.each(function() {
                T.event.add(this, e, i, n, t)
            })
        },
        one: function(e, t, n, i) {
            return this.on(e, t, n, i, 1)
        },
        off: function(e, t, n) {
            var i, r;
            if (e && e.preventDefault && e.handleObj) return i = e.handleObj, T(e.delegateTarget).off(i.namespace ? i.origType + "." + i.namespace : i.origType, i.selector, i.handler), this;
            if ("object" != typeof e) return !1 !== t && "function" != typeof t || (n = t, t = void 0), !1 === n && (n = ee), this.each(function() {
                T.event.remove(this, e, n, t)
            });
            for (r in e) this.off(r, t, e[r]);
            return this
        },
        trigger: function(e, t) {
            return this.each(function() {
                T.event.trigger(e, t, this)
            })
        },
        triggerHandler: function(e, t) {
            var n = this[0];
            return n ? T.event.trigger(e, t, n, !0) : void 0
        }
    });
    var ie = "abbr|article|aside|audio|bdi|canvas|data|datalist|details|figcaption|figure|footer|header|hgroup|mark|meter|nav|output|progress|section|summary|time|video",
        re = / jQuery\d+="(?:null|\d+)"/g,
        ae = new RegExp("<(?:" + ie + ")[\\s/>]", "i"),
        oe = /^\s+/,
        se = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:]+)[^>]*)\/>/gi,
        le = /<([\w:]+)/,
        ce = /<tbody/i,
        de = /<|&#?\w+;/,
        ue = /<(?:script|style|link)/i,
        pe = /checked\s*(?:[^=]|=\s*.checked.)/i,
        fe = /^$|\/(?:java|ecma)script/i,
        he = /^true\/(.*)/,
        me = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g,
        ge = {
            option: [1, "<select multiple='multiple'>", "</select>"],
            legend: [1, "<fieldset>", "</fieldset>"],
            area: [1, "<map>", "</map>"],
            param: [1, "<object>", "</object>"],
            thead: [1, "<table>", "</table>"],
            tr: [2, "<table><tbody>", "</tbody></table>"],
            col: [2, "<table><tbody></tbody><colgroup>", "</colgroup></table>"],
            td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
            _default: v.htmlSerialize ? [0, "", ""] : [1, "X<div>", "</div>"]
        },
        ve = ne(k).appendChild(k.createElement("div"));

    function _e(e, t) {
        var n, i, r = 0,
            a = typeof e.getElementsByTagName !== q ? e.getElementsByTagName(t || "*") : typeof e.querySelectorAll !== q ? e.querySelectorAll(t || "*") : void 0;
        if (!a)
            for (a = [], n = e.childNodes || e; null != (i = n[r]); r++) !t || T.nodeName(i, t) ? a.push(i) : T.merge(a, _e(i, t));
        return void 0 === t || t && T.nodeName(e, t) ? T.merge([e], a) : a
    }

    function ye(e) {
        Y.test(e.type) && (e.defaultChecked = e.checked)
    }

    function be(e, t) {
        return T.nodeName(e, "table") && T.nodeName(11 !== t.nodeType ? t : t.firstChild, "tr") ? e.getElementsByTagName("tbody")[0] || e.appendChild(e.ownerDocument.createElement("tbody")) : e
    }

    function xe(e) {
        return e.type = (null !== T.find.attr(e, "type")) + "/" + e.type, e
    }

    function we(e) {
        var t = he.exec(e.type);
        return t ? e.type = t[1] : e.removeAttribute("type"), e
    }

    function Te(e, t) {
        for (var n, i = 0; null != (n = e[i]); i++) T._data(n, "globalEval", !t || T._data(t[i], "globalEval"))
    }

    function Ce(e, t) {
        if (1 === t.nodeType && T.hasData(e)) {
            var n, i, r, a = T._data(e),
                o = T._data(t, a),
                s = a.events;
            if (s)
                for (n in delete o.handle, o.events = {}, s)
                    for (i = 0, r = s[n].length; i < r; i++) T.event.add(t, n, s[n][i]);
            o.data && (o.data = T.extend({}, o.data))
        }
    }

    function ke(e, t) {
        var n, i, r;
        if (1 === t.nodeType) {
            if (n = t.nodeName.toLowerCase(), !v.noCloneEvent && t[T.expando]) {
                for (i in (r = T._data(t)).events) T.removeEvent(t, i, r.handle);
                t.removeAttribute(T.expando)
            }
            "script" === n && t.text !== e.text ? (xe(t).text = e.text, we(t)) : "object" === n ? (t.parentNode && (t.outerHTML = e.outerHTML), v.html5Clone && e.innerHTML && !T.trim(t.innerHTML) && (t.innerHTML = e.innerHTML)) : "input" === n && Y.test(e.type) ? (t.defaultChecked = t.checked = e.checked, t.value !== e.value && (t.value = e.value)) : "option" === n ? t.defaultSelected = t.selected = e.defaultSelected : "input" !== n && "textarea" !== n || (t.defaultValue = e.defaultValue)
        }
    }
    ge.optgroup = ge.option, ge.tbody = ge.tfoot = ge.colgroup = ge.caption = ge.thead, ge.th = ge.td, T.extend({
        clone: function(e, t, n) {
            var i, r, a, o, s, l = T.contains(e.ownerDocument, e);
            if (v.html5Clone || T.isXMLDoc(e) || !ae.test("<" + e.nodeName + ">") ? a = e.cloneNode(!0) : (ve.innerHTML = e.outerHTML, ve.removeChild(a = ve.firstChild)), !(v.noCloneEvent && v.noCloneChecked || 1 !== e.nodeType && 11 !== e.nodeType || T.isXMLDoc(e)))
                for (i = _e(a), s = _e(e), o = 0; null != (r = s[o]); ++o) i[o] && ke(r, i[o]);
            if (t)
                if (n)
                    for (s = s || _e(e), i = i || _e(a), o = 0; null != (r = s[o]); o++) Ce(r, i[o]);
                else Ce(e, a);
            return 0 < (i = _e(a, "script")).length && Te(i, !l && _e(e, "script")), i = s = r = null, a
        },
        buildFragment: function(e, t, n, i) {
            for (var r, a, o, s, l, c, d, u = e.length, p = ne(t), f = [], h = 0; h < u; h++)
                if ((a = e[h]) || 0 === a)
                    if ("object" === T.type(a)) T.merge(f, a.nodeType ? [a] : a);
                    else if (de.test(a)) {
                        for (s = s || p.appendChild(t.createElement("div")), l = (le.exec(a) || ["", ""])[1].toLowerCase(), d = ge[l] || ge._default, s.innerHTML = d[1] + a.replace(se, "<$1></$2>") + d[2], r = d[0]; r--;) s = s.lastChild;
                        if (!v.leadingWhitespace && oe.test(a) && f.push(t.createTextNode(oe.exec(a)[0])), !v.tbody)
                            for (r = (a = "table" !== l || ce.test(a) ? "<table>" !== d[1] || ce.test(a) ? 0 : s : s.firstChild) && a.childNodes.length; r--;) T.nodeName(c = a.childNodes[r], "tbody") && !c.childNodes.length && a.removeChild(c);
                        for (T.merge(f, s.childNodes), s.textContent = ""; s.firstChild;) s.removeChild(s.firstChild);
                        s = p.lastChild
                    } else f.push(t.createTextNode(a));
            for (s && p.removeChild(s), v.appendChecked || T.grep(_e(f, "input"), ye), h = 0; a = f[h++];)
                if ((!i || -1 === T.inArray(a, i)) && (o = T.contains(a.ownerDocument, a), s = _e(p.appendChild(a), "script"), o && Te(s), n))
                    for (r = 0; a = s[r++];) fe.test(a.type || "") && n.push(a);
            return s = null, p
        },
        cleanData: function(e, t) {
            for (var n, i, r, a, o = 0, s = T.expando, l = T.cache, c = v.deleteExpando, d = T.event.special; null != (n = e[o]); o++)
                if ((t || T.acceptData(n)) && (a = (r = n[s]) && l[r])) {
                    if (a.events)
                        for (i in a.events) d[i] ? T.event.remove(n, i) : T.removeEvent(n, i, a.handle);
                    l[r] && (delete l[r], c ? delete n[s] : typeof n.removeAttribute !== q ? n.removeAttribute(s) : n[s] = null, u.push(r))
                }
        }
    }), T.fn.extend({
        text: function(e) {
            return V(this, function(e) {
                return void 0 === e ? T.text(this) : this.empty().append((this[0] && this[0].ownerDocument || k).createTextNode(e))
            }, null, e, arguments.length)
        },
        append: function() {
            return this.domManip(arguments, function(e) {
                1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || be(this, e).appendChild(e)
            })
        },
        prepend: function() {
            return this.domManip(arguments, function(e) {
                if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
                    var t = be(this, e);
                    t.insertBefore(e, t.firstChild)
                }
            })
        },
        before: function() {
            return this.domManip(arguments, function(e) {
                this.parentNode && this.parentNode.insertBefore(e, this)
            })
        },
        after: function() {
            return this.domManip(arguments, function(e) {
                this.parentNode && this.parentNode.insertBefore(e, this.nextSibling)
            })
        },
        remove: function(e, t) {
            for (var n, i = e ? T.filter(e, this) : this, r = 0; null != (n = i[r]); r++) t || 1 !== n.nodeType || T.cleanData(_e(n)), n.parentNode && (t && T.contains(n.ownerDocument, n) && Te(_e(n, "script")), n.parentNode.removeChild(n));
            return this
        },
        empty: function() {
            for (var e, t = 0; null != (e = this[t]); t++) {
                for (1 === e.nodeType && T.cleanData(_e(e, !1)); e.firstChild;) e.removeChild(e.firstChild);
                e.options && T.nodeName(e, "select") && (e.options.length = 0)
            }
            return this
        },
        clone: function(e, t) {
            return e = null != e && e, t = null == t ? e : t, this.map(function() {
                return T.clone(this, e, t)
            })
        },
        html: function(e) {
            return V(this, function(e) {
                var t = this[0] || {},
                    n = 0,
                    i = this.length;
                if (void 0 === e) return 1 === t.nodeType ? t.innerHTML.replace(re, "") : void 0;
                if (!("string" != typeof e || ue.test(e) || !v.htmlSerialize && ae.test(e) || !v.leadingWhitespace && oe.test(e) || ge[(le.exec(e) || ["", ""])[1].toLowerCase()])) {
                    e = e.replace(se, "<$1></$2>");
                    try {
                        for (; n < i; n++) 1 === (t = this[n] || {}).nodeType && (T.cleanData(_e(t, !1)), t.innerHTML = e);
                        t = 0
                    } catch (e) {}
                }
                t && this.empty().append(e)
            }, null, e, arguments.length)
        },
        replaceWith: function() {
            var t = arguments[0];
            return this.domManip(arguments, function(e) {
                t = this.parentNode, T.cleanData(_e(this)), t && t.replaceChild(e, this)
            }), t && (t.length || t.nodeType) ? this : this.remove()
        },
        detach: function(e) {
            return this.remove(e, !0)
        },
        domManip: function(n, i) {
            n = m.apply([], n);
            var e, t, r, a, o, s, l = 0,
                c = this.length,
                d = this,
                u = c - 1,
                p = n[0],
                f = T.isFunction(p);
            if (f || 1 < c && "string" == typeof p && !v.checkClone && pe.test(p)) return this.each(function(e) {
                var t = d.eq(e);
                f && (n[0] = p.call(this, e, t.html())), t.domManip(n, i)
            });
            if (c && (e = (s = T.buildFragment(n, this[0].ownerDocument, !1, this)).firstChild, 1 === s.childNodes.length && (s = e), e)) {
                for (r = (a = T.map(_e(s, "script"), xe)).length; l < c; l++) t = s, l !== u && (t = T.clone(t, !0, !0), r && T.merge(a, _e(t, "script"))), i.call(this[l], t, l);
                if (r)
                    for (o = a[a.length - 1].ownerDocument, T.map(a, we), l = 0; l < r; l++) t = a[l], fe.test(t.type || "") && !T._data(t, "globalEval") && T.contains(o, t) && (t.src ? T._evalUrl && T._evalUrl(t.src) : T.globalEval((t.text || t.textContent || t.innerHTML || "").replace(me, "")));
                s = e = null
            }
            return this
        }
    }), T.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(e, o) {
        T.fn[e] = function(e) {
            for (var t, n = 0, i = [], r = T(e), a = r.length - 1; n <= a; n++) t = n === a ? this : this.clone(!0), T(r[n])[o](t), s.apply(i, t.get());
            return this.pushStack(i)
        }
    });
    var Ee, Ne, Se, $e, Ae = {};

    function De(e, t) {
        var n = T(t.createElement(e)).appendTo(t.body),
            i = h.getDefaultComputedStyle ? h.getDefaultComputedStyle(n[0]).display : T.css(n[0], "display");
        return n.detach(), i
    }

    function je(e) {
        var t = k,
            n = Ae[e];
        return n || ("none" !== (n = De(e, t)) && n || ((t = ((Ee = (Ee || T("<iframe frameborder='0' width='0' height='0'/>")).appendTo(t.documentElement))[0].contentWindow || Ee[0].contentDocument).document).write(), t.close(), n = De(e, t), Ee.detach()), Ae[e] = n), n
    }($e = k.createElement("div")).innerHTML = "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>", (Ne = $e.getElementsByTagName("a")[0]).style.cssText = "float:left;opacity:.5", v.opacity = /^0.5/.test(Ne.style.opacity), v.cssFloat = !!Ne.style.cssFloat, $e.style.backgroundClip = "content-box", $e.cloneNode(!0).style.backgroundClip = "", v.clearCloneStyle = "content-box" === $e.style.backgroundClip, Ne = $e = null, v.shrinkWrapBlocks = function() {
        var e, t, n;
        if (null == Se) {
            if (!(e = k.getElementsByTagName("body")[0])) return;
            t = k.createElement("div"), n = k.createElement("div"), e.appendChild(t).appendChild(n), Se = !1, typeof n.style.zoom !== q && (n.style.cssText = "-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;display:block;padding:0;margin:0;border:0;width:1px;padding:1px;zoom:1", n.innerHTML = "<div></div>", n.firstChild.style.width = "5px", Se = 3 !== n.offsetWidth), e.removeChild(t), e = t = n = null
        }
        return Se
    };
    var Me, Le, He, qe, We, Pe, Oe, Be, Fe, ze, Ie = /^margin/,
        Re = new RegExp("^(" + R + ")(?!px)[a-z%]+$", "i"),
        Xe = /^(top|right|bottom|left)$/;

    function Ve(t, n) {
        return {
            get: function() {
                var e = t();
                if (null != e) return e ? void delete this.get : (this.get = n).apply(this, arguments)
            }
        }
    }

    function Ye() {
        var e, t, n = k.getElementsByTagName("body")[0];
        n && (e = k.createElement("div"), t = k.createElement("div"), e.style.cssText = ze, n.appendChild(e).appendChild(t), t.style.cssText = "-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;position:absolute;display:block;padding:1px;border:1px;width:4px;margin-top:1%;top:1%", T.swap(n, null != n.style.zoom ? {
            zoom: 1
        } : {}, function() {
            We = 4 === t.offsetWidth
        }), Be = !(Oe = !(Pe = !0)), h.getComputedStyle && (Oe = "1%" !== (h.getComputedStyle(t, null) || {}).top, Pe = "4px" === (h.getComputedStyle(t, null) || {
            width: "4px"
        }).width), n.removeChild(e), t = n = null)
    }
    h.getComputedStyle ? (Me = function(e) {
        return e.ownerDocument.defaultView.getComputedStyle(e, null)
    }, Le = function(e, t, n) {
        var i, r, a, o, s = e.style;
        return o = (n = n || Me(e)) ? n.getPropertyValue(t) || n[t] : void 0, n && ("" !== o || T.contains(e.ownerDocument, e) || (o = T.style(e, t)), Re.test(o) && Ie.test(t) && (i = s.width, r = s.minWidth, a = s.maxWidth, s.minWidth = s.maxWidth = s.width = o, o = n.width, s.width = i, s.minWidth = r, s.maxWidth = a)), void 0 === o ? o : o + ""
    }) : k.documentElement.currentStyle && (Me = function(e) {
        return e.currentStyle
    }, Le = function(e, t, n) {
        var i, r, a, o, s = e.style;
        return null == (o = (n = n || Me(e)) ? n[t] : void 0) && s && s[t] && (o = s[t]), Re.test(o) && !Xe.test(t) && (i = s.left, (a = (r = e.runtimeStyle) && r.left) && (r.left = e.currentStyle.left), s.left = "fontSize" === t ? "1em" : o, o = s.pixelLeft + "px", s.left = i, a && (r.left = a)), void 0 === o ? o : o + "" || "auto"
    }), Fe = k.createElement("div"), ze = "border:0;width:0;height:0;position:absolute;top:0;left:-9999px", Fe.innerHTML = "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>", (He = Fe.getElementsByTagName("a")[0]).style.cssText = "float:left;opacity:.5", v.opacity = /^0.5/.test(He.style.opacity), v.cssFloat = !!He.style.cssFloat, Fe.style.backgroundClip = "content-box", Fe.cloneNode(!0).style.backgroundClip = "", v.clearCloneStyle = "content-box" === Fe.style.backgroundClip, He = Fe = null, T.extend(v, {
        reliableHiddenOffsets: function() {
            if (null != qe) return qe;
            var e, t, n, i = k.createElement("div"),
                r = k.getElementsByTagName("body")[0];
            return r ? (i.setAttribute("className", "t"), i.innerHTML = "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>", (e = k.createElement("div")).style.cssText = ze, r.appendChild(e).appendChild(i), i.innerHTML = "<table><tr><td></td><td>t</td></tr></table>", (t = i.getElementsByTagName("td"))[0].style.cssText = "padding:0;margin:0;border:0;display:none", n = 0 === t[0].offsetHeight, t[0].style.display = "", t[1].style.display = "none", qe = n && 0 === t[0].offsetHeight, r.removeChild(e), i = r = null, qe) : void 0
        },
        boxSizing: function() {
            return null == We && Ye(), We
        },
        boxSizingReliable: function() {
            return null == Pe && Ye(), Pe
        },
        pixelPosition: function() {
            return null == Oe && Ye(), Oe
        },
        reliableMarginRight: function() {
            var e, t, n, i;
            if (null == Be && h.getComputedStyle) {
                if (!(e = k.getElementsByTagName("body")[0])) return;
                t = k.createElement("div"), n = k.createElement("div"), t.style.cssText = ze, e.appendChild(t).appendChild(n), (i = n.appendChild(k.createElement("div"))).style.cssText = n.style.cssText = "-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;display:block;padding:0;margin:0;border:0", i.style.marginRight = i.style.width = "0", n.style.width = "1px", Be = !parseFloat((h.getComputedStyle(i, null) || {}).marginRight), e.removeChild(t)
            }
            return Be
        }
    }), T.swap = function(e, t, n, i) {
        var r, a, o = {};
        for (a in t) o[a] = e.style[a], e.style[a] = t[a];
        for (a in r = n.apply(e, i || []), t) e.style[a] = o[a];
        return r
    };
    var Ue = /alpha\([^)]*\)/i,
        Ge = /opacity\s*=\s*([^)]*)/,
        Qe = /^(none|table(?!-c[ea]).+)/,
        Je = new RegExp("^(" + R + ")(.*)$", "i"),
        Ke = new RegExp("^([+-])=(" + R + ")", "i"),
        Ze = {
            position: "absolute",
            visibility: "hidden",
            display: "block"
        },
        et = {
            letterSpacing: 0,
            fontWeight: 400
        },
        tt = ["Webkit", "O", "Moz", "ms"];

    function nt(e, t) {
        if (t in e) return t;
        for (var n = t.charAt(0).toUpperCase() + t.slice(1), i = t, r = tt.length; r--;)
            if ((t = tt[r] + n) in e) return t;
        return i
    }

    function it(e, t) {
        for (var n, i, r, a = [], o = 0, s = e.length; o < s; o++)(i = e[o]).style && (a[o] = T._data(i, "olddisplay"), n = i.style.display, t ? (a[o] || "none" !== n || (i.style.display = ""), "" === i.style.display && I(i) && (a[o] = T._data(i, "olddisplay", je(i.nodeName)))) : a[o] || (r = I(i), (n && "none" !== n || !r) && T._data(i, "olddisplay", r ? n : T.css(i, "display"))));
        for (o = 0; o < s; o++)(i = e[o]).style && (t && "none" !== i.style.display && "" !== i.style.display || (i.style.display = t ? a[o] || "" : "none"));
        return e
    }

    function rt(e, t, n) {
        var i = Je.exec(t);
        return i ? Math.max(0, i[1] - (n || 0)) + (i[2] || "px") : t
    }

    function at(e, t, n, i, r) {
        for (var a = n === (i ? "border" : "content") ? 4 : "width" === t ? 1 : 0, o = 0; a < 4; a += 2) "margin" === n && (o += T.css(e, n + X[a], !0, r)), i ? ("content" === n && (o -= T.css(e, "padding" + X[a], !0, r)), "margin" !== n && (o -= T.css(e, "border" + X[a] + "Width", !0, r))) : (o += T.css(e, "padding" + X[a], !0, r), "padding" !== n && (o += T.css(e, "border" + X[a] + "Width", !0, r)));
        return o
    }

    function ot(e, t, n) {
        var i = !0,
            r = "width" === t ? e.offsetWidth : e.offsetHeight,
            a = Me(e),
            o = v.boxSizing() && "border-box" === T.css(e, "boxSizing", !1, a);
        if (r <= 0 || null == r) {
            if (((r = Le(e, t, a)) < 0 || null == r) && (r = e.style[t]), Re.test(r)) return r;
            i = o && (v.boxSizingReliable() || r === e.style[t]), r = parseFloat(r) || 0
        }
        return r + at(e, t, n || (o ? "border" : "content"), i, a) + "px"
    }

    function st(e, t, n, i, r) {
        return new st.prototype.init(e, t, n, i, r)
    }
    T.extend({
        cssHooks: {
            opacity: {
                get: function(e, t) {
                    if (t) {
                        var n = Le(e, "opacity");
                        return "" === n ? "1" : n
                    }
                }
            }
        },
        cssNumber: {
            columnCount: !0,
            fillOpacity: !0,
            fontWeight: !0,
            lineHeight: !0,
            opacity: !0,
            order: !0,
            orphans: !0,
            widows: !0,
            zIndex: !0,
            zoom: !0
        },
        cssProps: {
            float: v.cssFloat ? "cssFloat" : "styleFloat"
        },
        style: function(e, t, n, i) {
            if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
                var r, a, o, s = T.camelCase(t),
                    l = e.style;
                if (t = T.cssProps[s] || (T.cssProps[s] = nt(l, s)), o = T.cssHooks[t] || T.cssHooks[s], void 0 === n) return o && "get" in o && void 0 !== (r = o.get(e, !1, i)) ? r : l[t];
                if ("string" === (a = typeof n) && (r = Ke.exec(n)) && (n = (r[1] + 1) * r[2] + parseFloat(T.css(e, t)), a = "number"), null != n && n == n && ("number" !== a || T.cssNumber[s] || (n += "px"), v.clearCloneStyle || "" !== n || 0 !== t.indexOf("background") || (l[t] = "inherit"), !(o && "set" in o && void 0 === (n = o.set(e, n, i))))) try {
                    l[t] = "", l[t] = n
                } catch (e) {}
            }
        },
        css: function(e, t, n, i) {
            var r, a, o, s = T.camelCase(t);
            return t = T.cssProps[s] || (T.cssProps[s] = nt(e.style, s)), (o = T.cssHooks[t] || T.cssHooks[s]) && "get" in o && (a = o.get(e, !0, n)), void 0 === a && (a = Le(e, t, i)), "normal" === a && t in et && (a = et[t]), "" === n || n ? (r = parseFloat(a), !0 === n || T.isNumeric(r) ? r || 0 : a) : a
        }
    }), T.each(["height", "width"], function(e, r) {
        T.cssHooks[r] = {
            get: function(e, t, n) {
                return t ? 0 === e.offsetWidth && Qe.test(T.css(e, "display")) ? T.swap(e, Ze, function() {
                    return ot(e, r, n)
                }) : ot(e, r, n) : void 0
            },
            set: function(e, t, n) {
                var i = n && Me(e);
                return rt(0, t, n ? at(e, r, n, v.boxSizing() && "border-box" === T.css(e, "boxSizing", !1, i), i) : 0)
            }
        }
    }), v.opacity || (T.cssHooks.opacity = {
        get: function(e, t) {
            return Ge.test((t && e.currentStyle ? e.currentStyle.filter : e.style.filter) || "") ? .01 * parseFloat(RegExp.$1) + "" : t ? "1" : ""
        },
        set: function(e, t) {
            var n = e.style,
                i = e.currentStyle,
                r = T.isNumeric(t) ? "alpha(opacity=" + 100 * t + ")" : "",
                a = i && i.filter || n.filter || "";
            ((n.zoom = 1) <= t || "" === t) && "" === T.trim(a.replace(Ue, "")) && n.removeAttribute && (n.removeAttribute("filter"), "" === t || i && !i.filter) || (n.filter = Ue.test(a) ? a.replace(Ue, r) : a + " " + r)
        }
    }), T.cssHooks.marginRight = Ve(v.reliableMarginRight, function(e, t) {
        return t ? T.swap(e, {
            display: "inline-block"
        }, Le, [e, "marginRight"]) : void 0
    }), T.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(r, a) {
        T.cssHooks[r + a] = {
            expand: function(e) {
                for (var t = 0, n = {}, i = "string" == typeof e ? e.split(" ") : [e]; t < 4; t++) n[r + X[t] + a] = i[t] || i[t - 2] || i[0];
                return n
            }
        }, Ie.test(r) || (T.cssHooks[r + a].set = rt)
    }), T.fn.extend({
        css: function(e, t) {
            return V(this, function(e, t, n) {
                var i, r, a = {},
                    o = 0;
                if (T.isArray(t)) {
                    for (i = Me(e), r = t.length; o < r; o++) a[t[o]] = T.css(e, t[o], !1, i);
                    return a
                }
                return void 0 !== n ? T.style(e, t, n) : T.css(e, t)
            }, e, t, 1 < arguments.length)
        },
        show: function() {
            return it(this, !0)
        },
        hide: function() {
            return it(this)
        },
        toggle: function(e) {
            return "boolean" == typeof e ? e ? this.show() : this.hide() : this.each(function() {
                I(this) ? T(this).show() : T(this).hide()
            })
        }
    }), ((T.Tween = st).prototype = {
        constructor: st,
        init: function(e, t, n, i, r, a) {
            this.elem = e, this.prop = n, this.easing = r || "swing", this.options = t, this.start = this.now = this.cur(), this.end = i, this.unit = a || (T.cssNumber[n] ? "" : "px")
        },
        cur: function() {
            var e = st.propHooks[this.prop];
            return e && e.get ? e.get(this) : st.propHooks._default.get(this)
        },
        run: function(e) {
            var t, n = st.propHooks[this.prop];
            return this.pos = t = this.options.duration ? T.easing[this.easing](e, this.options.duration * e, 0, 1, this.options.duration) : e, this.now = (this.end - this.start) * t + this.start, this.options.step && this.options.step.call(this.elem, this.now, this), n && n.set ? n.set(this) : st.propHooks._default.set(this), this
        }
    }).init.prototype = st.prototype, (st.propHooks = {
        _default: {
            get: function(e) {
                var t;
                return null == e.elem[e.prop] || e.elem.style && null != e.elem.style[e.prop] ? (t = T.css(e.elem, e.prop, "")) && "auto" !== t ? t : 0 : e.elem[e.prop]
            },
            set: function(e) {
                T.fx.step[e.prop] ? T.fx.step[e.prop](e) : e.elem.style && (null != e.elem.style[T.cssProps[e.prop]] || T.cssHooks[e.prop]) ? T.style(e.elem, e.prop, e.now + e.unit) : e.elem[e.prop] = e.now
            }
        }
    }).scrollTop = st.propHooks.scrollLeft = {
        set: function(e) {
            e.elem.nodeType && e.elem.parentNode && (e.elem[e.prop] = e.now)
        }
    }, T.easing = {
        linear: function(e) {
            return e
        },
        swing: function(e) {
            return .5 - Math.cos(e * Math.PI) / 2
        }
    }, T.fx = st.prototype.init, T.fx.step = {};
    var lt, ct, dt, ut, pt, ft, ht, mt = /^(?:toggle|show|hide)$/,
        gt = new RegExp("^(?:([+-])=|)(" + R + ")([a-z%]*)$", "i"),
        vt = /queueHooks$/,
        _t = [function(t, e, n) {
            var i, r, a, o, s, l, c, d, u = this,
                p = {},
                f = t.style,
                h = t.nodeType && I(t),
                m = T._data(t, "fxshow");
            for (i in n.queue || (null == (s = T._queueHooks(t, "fx")).unqueued && (s.unqueued = 0, l = s.empty.fire, s.empty.fire = function() {
                s.unqueued || l()
            }), s.unqueued++, u.always(function() {
                u.always(function() {
                    s.unqueued--, T.queue(t, "fx").length || s.empty.fire()
                })
            })), 1 === t.nodeType && ("height" in e || "width" in e) && (n.overflow = [f.overflow, f.overflowX, f.overflowY], c = T.css(t, "display"), d = je(t.nodeName), "none" === c && (c = d), "inline" === c && "none" === T.css(t, "float") && (v.inlineBlockNeedsLayout && "inline" !== d ? f.zoom = 1 : f.display = "inline-block")), n.overflow && (f.overflow = "hidden", v.shrinkWrapBlocks() || u.always(function() {
                f.overflow = n.overflow[0], f.overflowX = n.overflow[1], f.overflowY = n.overflow[2]
            })), e)
                if (r = e[i], mt.exec(r)) {
                    if (delete e[i], a = a || "toggle" === r, r === (h ? "hide" : "show")) {
                        if ("show" !== r || !m || void 0 === m[i]) continue;
                        h = !0
                    }
                    p[i] = m && m[i] || T.style(t, i)
                }
            if (!T.isEmptyObject(p))
                for (i in m ? "hidden" in m && (h = m.hidden) : m = T._data(t, "fxshow", {}), a && (m.hidden = !h), h ? T(t).show() : u.done(function() {
                    T(t).hide()
                }), u.done(function() {
                    var e;
                    for (e in T._removeData(t, "fxshow"), p) T.style(t, e, p[e])
                }), p) o = wt(h ? m[i] : 0, i, u), i in m || (m[i] = o.start, h && (o.end = o.start, o.start = "width" === i || "height" === i ? 1 : 0))
        }],
        yt = {
            "*": [function(e, t) {
                var n = this.createTween(e, t),
                    i = n.cur(),
                    r = gt.exec(t),
                    a = r && r[3] || (T.cssNumber[e] ? "" : "px"),
                    o = (T.cssNumber[e] || "px" !== a && +i) && gt.exec(T.css(n.elem, e)),
                    s = 1,
                    l = 20;
                if (o && o[3] !== a)
                    for (a = a || o[3], r = r || [], o = +i || 1; o /= s = s || ".5", T.style(n.elem, e, o + a), s !== (s = n.cur() / i) && 1 !== s && --l;);
                return r && (o = n.start = +o || +i || 0, n.unit = a, n.end = r[1] ? o + (r[1] + 1) * r[2] : +r[2]), n
            }]
        };

    function bt() {
        return setTimeout(function() {
            lt = void 0
        }), lt = T.now()
    }

    function xt(e, t) {
        var n, i = {
                height: e
            },
            r = 0;
        for (t = t ? 1 : 0; r < 4; r += 2 - t) i["margin" + (n = X[r])] = i["padding" + n] = e;
        return t && (i.opacity = i.width = e), i
    }

    function wt(e, t, n) {
        for (var i, r = (yt[t] || []).concat(yt["*"]), a = 0, o = r.length; a < o; a++)
            if (i = r[a].call(n, t, e)) return i
    }

    function Tt(a, e, t) {
        var n, o, i = 0,
            r = _t.length,
            s = T.Deferred().always(function() {
                delete l.elem
            }),
            l = function() {
                if (o) return !1;
                for (var e = lt || bt(), t = Math.max(0, c.startTime + c.duration - e), n = 1 - (t / c.duration || 0), i = 0, r = c.tweens.length; i < r; i++) c.tweens[i].run(n);
                return s.notifyWith(a, [c, n, t]), n < 1 && r ? t : (s.resolveWith(a, [c]), !1)
            },
            c = s.promise({
                elem: a,
                props: T.extend({}, e),
                opts: T.extend(!0, {
                    specialEasing: {}
                }, t),
                originalProperties: e,
                originalOptions: t,
                startTime: lt || bt(),
                duration: t.duration,
                tweens: [],
                createTween: function(e, t) {
                    var n = T.Tween(a, c.opts, e, t, c.opts.specialEasing[e] || c.opts.easing);
                    return c.tweens.push(n), n
                },
                stop: function(e) {
                    var t = 0,
                        n = e ? c.tweens.length : 0;
                    if (o) return this;
                    for (o = !0; t < n; t++) c.tweens[t].run(1);
                    return e ? s.resolveWith(a, [c, e]) : s.rejectWith(a, [c, e]), this
                }
            }),
            d = c.props;
        for (function(e, t) {
            var n, i, r, a, o;
            for (n in e)
                if (r = t[i = T.camelCase(n)], a = e[n], T.isArray(a) && (r = a[1], a = e[n] = a[0]), n !== i && (e[i] = a, delete e[n]), (o = T.cssHooks[i]) && "expand" in o)
                    for (n in a = o.expand(a), delete e[i], a) n in e || (e[n] = a[n], t[n] = r);
                else t[i] = r
        }(d, c.opts.specialEasing); i < r; i++)
            if (n = _t[i].call(c, a, d, c.opts)) return n;
        return T.map(d, wt, c), T.isFunction(c.opts.start) && c.opts.start.call(a, c), T.fx.timer(T.extend(l, {
            elem: a,
            anim: c,
            queue: c.opts.queue
        })), c.progress(c.opts.progress).done(c.opts.done, c.opts.complete).fail(c.opts.fail).always(c.opts.always)
    }
    T.Animation = T.extend(Tt, {
        tweener: function(e, t) {
            for (var n, i = 0, r = (e = T.isFunction(e) ? (t = e, ["*"]) : e.split(" ")).length; i < r; i++) n = e[i], yt[n] = yt[n] || [], yt[n].unshift(t)
        },
        prefilter: function(e, t) {
            t ? _t.unshift(e) : _t.push(e)
        }
    }), T.speed = function(e, t, n) {
        var i = e && "object" == typeof e ? T.extend({}, e) : {
            complete: n || !n && t || T.isFunction(e) && e,
            duration: e,
            easing: n && t || t && !T.isFunction(t) && t
        };
        return i.duration = T.fx.off ? 0 : "number" == typeof i.duration ? i.duration : i.duration in T.fx.speeds ? T.fx.speeds[i.duration] : T.fx.speeds._default, null != i.queue && !0 !== i.queue || (i.queue = "fx"), i.old = i.complete, i.complete = function() {
            T.isFunction(i.old) && i.old.call(this), i.queue && T.dequeue(this, i.queue)
        }, i
    }, T.fn.extend({
        fadeTo: function(e, t, n, i) {
            return this.filter(I).css("opacity", 0).show().end().animate({
                opacity: t
            }, e, n, i)
        },
        animate: function(t, e, n, i) {
            function r() {
                var e = Tt(this, T.extend({}, t), o);
                (a || T._data(this, "finish")) && e.stop(!0)
            }
            var a = T.isEmptyObject(t),
                o = T.speed(e, n, i);
            return r.finish = r, a || !1 === o.queue ? this.each(r) : this.queue(o.queue, r)
        },
        stop: function(r, e, a) {
            function o(e) {
                var t = e.stop;
                delete e.stop, t(a)
            }
            return "string" != typeof r && (a = e, e = r, r = void 0), e && !1 !== r && this.queue(r || "fx", []), this.each(function() {
                var e = !0,
                    t = null != r && r + "queueHooks",
                    n = T.timers,
                    i = T._data(this);
                if (t) i[t] && i[t].stop && o(i[t]);
                else
                    for (t in i) i[t] && i[t].stop && vt.test(t) && o(i[t]);
                for (t = n.length; t--;) n[t].elem !== this || null != r && n[t].queue !== r || (n[t].anim.stop(a), e = !1, n.splice(t, 1));
                !e && a || T.dequeue(this, r)
            })
        },
        finish: function(o) {
            return !1 !== o && (o = o || "fx"), this.each(function() {
                var e, t = T._data(this),
                    n = t[o + "queue"],
                    i = t[o + "queueHooks"],
                    r = T.timers,
                    a = n ? n.length : 0;
                for (t.finish = !0, T.queue(this, o, []), i && i.stop && i.stop.call(this, !0), e = r.length; e--;) r[e].elem === this && r[e].queue === o && (r[e].anim.stop(!0), r.splice(e, 1));
                for (e = 0; e < a; e++) n[e] && n[e].finish && n[e].finish.call(this);
                delete t.finish
            })
        }
    }), T.each(["toggle", "show", "hide"], function(e, i) {
        var r = T.fn[i];
        T.fn[i] = function(e, t, n) {
            return null == e || "boolean" == typeof e ? r.apply(this, arguments) : this.animate(xt(i, !0), e, t, n)
        }
    }), T.each({
        slideDown: xt("show"),
        slideUp: xt("hide"),
        slideToggle: xt("toggle"),
        fadeIn: {
            opacity: "show"
        },
        fadeOut: {
            opacity: "hide"
        },
        fadeToggle: {
            opacity: "toggle"
        }
    }, function(e, i) {
        T.fn[e] = function(e, t, n) {
            return this.animate(i, e, t, n)
        }
    }), T.timers = [], T.fx.tick = function() {
        var e, t = T.timers,
            n = 0;
        for (lt = T.now(); n < t.length; n++)(e = t[n])() || t[n] !== e || t.splice(n--, 1);
        t.length || T.fx.stop(), lt = void 0
    }, T.fx.timer = function(e) {
        T.timers.push(e), e() ? T.fx.start() : T.timers.pop()
    }, T.fx.interval = 13, T.fx.start = function() {
        ct = ct || setInterval(T.fx.tick, T.fx.interval)
    }, T.fx.stop = function() {
        clearInterval(ct), ct = null
    }, T.fx.speeds = {
        slow: 600,
        fast: 200,
        _default: 400
    }, T.fn.delay = function(i, e) {
        return i = T.fx && T.fx.speeds[i] || i, e = e || "fx", this.queue(e, function(e, t) {
            var n = setTimeout(e, i);
            t.stop = function() {
                clearTimeout(n)
            }
        })
    }, (ht = k.createElement("div")).setAttribute("className", "t"), ht.innerHTML = "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>", dt = ht.getElementsByTagName("a")[0], ft = (pt = k.createElement("select")).appendChild(k.createElement("option")), ut = ht.getElementsByTagName("input")[0], dt.style.cssText = "top:1px", v.getSetAttribute = "t" !== ht.className, v.style = /top/.test(dt.getAttribute("style")), v.hrefNormalized = "/a" === dt.getAttribute("href"), v.checkOn = !!ut.value, v.optSelected = ft.selected, v.enctype = !!k.createElement("form").enctype, pt.disabled = !0, v.optDisabled = !ft.disabled, (ut = k.createElement("input")).setAttribute("value", ""), v.input = "" === ut.getAttribute("value"), ut.value = "t", ut.setAttribute("type", "radio"), v.radioValue = "t" === ut.value, dt = ut = pt = ft = ht = null;
    var Ct = /\r/g;
    T.fn.extend({
        val: function(n) {
            var i, e, r, t = this[0];
            return arguments.length ? (r = T.isFunction(n), this.each(function(e) {
                var t;
                1 === this.nodeType && (null == (t = r ? n.call(this, e, T(this).val()) : n) ? t = "" : "number" == typeof t ? t += "" : T.isArray(t) && (t = T.map(t, function(e) {
                    return null == e ? "" : e + ""
                })), (i = T.valHooks[this.type] || T.valHooks[this.nodeName.toLowerCase()]) && "set" in i && void 0 !== i.set(this, t, "value") || (this.value = t))
            })) : t ? (i = T.valHooks[t.type] || T.valHooks[t.nodeName.toLowerCase()]) && "get" in i && void 0 !== (e = i.get(t, "value")) ? e : "string" == typeof(e = t.value) ? e.replace(Ct, "") : null == e ? "" : e : void 0
        }
    }), T.extend({
        valHooks: {
            option: {
                get: function(e) {
                    var t = T.find.attr(e, "value");
                    return null != t ? t : T.text(e)
                }
            },
            select: {
                get: function(e) {
                    for (var t, n, i = e.options, r = e.selectedIndex, a = "select-one" === e.type || r < 0, o = a ? null : [], s = a ? r + 1 : i.length, l = r < 0 ? s : a ? r : 0; l < s; l++)
                        if (!(!(n = i[l]).selected && l !== r || (v.optDisabled ? n.disabled : null !== n.getAttribute("disabled")) || n.parentNode.disabled && T.nodeName(n.parentNode, "optgroup"))) {
                            if (t = T(n).val(), a) return t;
                            o.push(t)
                        }
                    return o
                },
                set: function(e, t) {
                    for (var n, i, r = e.options, a = T.makeArray(t), o = r.length; o--;)
                        if (i = r[o], 0 <= T.inArray(T.valHooks.option.get(i), a)) try {
                            i.selected = n = !0
                        } catch (e) {
                            i.scrollHeight
                        } else i.selected = !1;
                    return n || (e.selectedIndex = -1), r
                }
            }
        }
    }), T.each(["radio", "checkbox"], function() {
        T.valHooks[this] = {
            set: function(e, t) {
                return T.isArray(t) ? e.checked = 0 <= T.inArray(T(e).val(), t) : void 0
            }
        }, v.checkOn || (T.valHooks[this].get = function(e) {
            return null === e.getAttribute("value") ? "on" : e.value
        })
    });
    var kt, Et, Nt = T.expr.attrHandle,
        St = /^(?:checked|selected)$/i,
        $t = v.getSetAttribute,
        At = v.input;
    T.fn.extend({
        attr: function(e, t) {
            return V(this, T.attr, e, t, 1 < arguments.length)
        },
        removeAttr: function(e) {
            return this.each(function() {
                T.removeAttr(this, e)
            })
        }
    }), T.extend({
        attr: function(e, t, n) {
            var i, r, a = e.nodeType;
            if (e && 3 !== a && 8 !== a && 2 !== a) return typeof e.getAttribute === q ? T.prop(e, t, n) : (1 === a && T.isXMLDoc(e) || (t = t.toLowerCase(), i = T.attrHooks[t] || (T.expr.match.bool.test(t) ? Et : kt)), void 0 === n ? i && "get" in i && null !== (r = i.get(e, t)) ? r : null == (r = T.find.attr(e, t)) ? void 0 : r : null !== n ? i && "set" in i && void 0 !== (r = i.set(e, n, t)) ? r : (e.setAttribute(t, n + ""), n) : void T.removeAttr(e, t))
        },
        removeAttr: function(e, t) {
            var n, i, r = 0,
                a = t && t.match(D);
            if (a && 1 === e.nodeType)
                for (; n = a[r++];) i = T.propFix[n] || n, T.expr.match.bool.test(n) ? At && $t || !St.test(n) ? e[i] = !1 : e[T.camelCase("default-" + n)] = e[i] = !1 : T.attr(e, n, ""), e.removeAttribute($t ? n : i)
        },
        attrHooks: {
            type: {
                set: function(e, t) {
                    if (!v.radioValue && "radio" === t && T.nodeName(e, "input")) {
                        var n = e.value;
                        return e.setAttribute("type", t), n && (e.value = n), t
                    }
                }
            }
        }
    }), Et = {
        set: function(e, t, n) {
            return !1 === t ? T.removeAttr(e, n) : At && $t || !St.test(n) ? e.setAttribute(!$t && T.propFix[n] || n, n) : e[T.camelCase("default-" + n)] = e[n] = !0, n
        }
    }, T.each(T.expr.match.bool.source.match(/\w+/g), function(e, t) {
        var a = Nt[t] || T.find.attr;
        Nt[t] = At && $t || !St.test(t) ? function(e, t, n) {
            var i, r;
            return n || (r = Nt[t], Nt[t] = i, i = null != a(e, t, n) ? t.toLowerCase() : null, Nt[t] = r), i
        } : function(e, t, n) {
            return n ? void 0 : e[T.camelCase("default-" + t)] ? t.toLowerCase() : null
        }
    }), At && $t || (T.attrHooks.value = {
        set: function(e, t, n) {
            return T.nodeName(e, "input") ? void(e.defaultValue = t) : kt && kt.set(e, t, n)
        }
    }), $t || (kt = {
        set: function(e, t, n) {
            var i = e.getAttributeNode(n);
            return i || e.setAttributeNode(i = e.ownerDocument.createAttribute(n)), i.value = t += "", "value" === n || t === e.getAttribute(n) ? t : void 0
        }
    }, Nt.id = Nt.name = Nt.coords = function(e, t, n) {
        var i;
        return n ? void 0 : (i = e.getAttributeNode(t)) && "" !== i.value ? i.value : null
    }, T.valHooks.button = {
        get: function(e, t) {
            var n = e.getAttributeNode(t);
            return n && n.specified ? n.value : void 0
        },
        set: kt.set
    }, T.attrHooks.contenteditable = {
        set: function(e, t, n) {
            kt.set(e, "" !== t && t, n)
        }
    }, T.each(["width", "height"], function(e, n) {
        T.attrHooks[n] = {
            set: function(e, t) {
                return "" === t ? (e.setAttribute(n, "auto"), t) : void 0
            }
        }
    })), v.style || (T.attrHooks.style = {
        get: function(e) {
            return e.style.cssText || void 0
        },
        set: function(e, t) {
            return e.style.cssText = t + ""
        }
    });
    var Dt = /^(?:input|select|textarea|button|object)$/i,
        jt = /^(?:a|area)$/i;
    T.fn.extend({
        prop: function(e, t) {
            return V(this, T.prop, e, t, 1 < arguments.length)
        },
        removeProp: function(e) {
            return e = T.propFix[e] || e, this.each(function() {
                try {
                    this[e] = void 0, delete this[e]
                } catch (e) {}
            })
        }
    }), T.extend({
        propFix: {
            for: "htmlFor",
            class: "className"
        },
        prop: function(e, t, n) {
            var i, r, a = e.nodeType;
            if (e && 3 !== a && 8 !== a && 2 !== a) return (1 !== a || !T.isXMLDoc(e)) && (t = T.propFix[t] || t, r = T.propHooks[t]), void 0 !== n ? r && "set" in r && void 0 !== (i = r.set(e, n, t)) ? i : e[t] = n : r && "get" in r && null !== (i = r.get(e, t)) ? i : e[t]
        },
        propHooks: {
            tabIndex: {
                get: function(e) {
                    var t = T.find.attr(e, "tabindex");
                    return t ? parseInt(t, 10) : Dt.test(e.nodeName) || jt.test(e.nodeName) && e.href ? 0 : -1
                }
            }
        }
    }), v.hrefNormalized || T.each(["href", "src"], function(e, t) {
        T.propHooks[t] = {
            get: function(e) {
                return e.getAttribute(t, 4)
            }
        }
    }), v.optSelected || (T.propHooks.selected = {
        get: function(e) {
            var t = e.parentNode;
            return t && (t.selectedIndex, t.parentNode && t.parentNode.selectedIndex), null
        }
    }), T.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function() {
        T.propFix[this.toLowerCase()] = this
    }), v.enctype || (T.propFix.enctype = "encoding");
    var Mt = /[\t\r\n\f]/g;
    T.fn.extend({
        addClass: function(t) {
            var e, n, i, r, a, o, s = 0,
                l = this.length,
                c = "string" == typeof t && t;
            if (T.isFunction(t)) return this.each(function(e) {
                T(this).addClass(t.call(this, e, this.className))
            });
            if (c)
                for (e = (t || "").match(D) || []; s < l; s++)
                    if (i = 1 === (n = this[s]).nodeType && (n.className ? (" " + n.className + " ").replace(Mt, " ") : " ")) {
                        for (a = 0; r = e[a++];) i.indexOf(" " + r + " ") < 0 && (i += r + " ");
                        o = T.trim(i), n.className !== o && (n.className = o)
                    }
            return this
        },
        removeClass: function(t) {
            var e, n, i, r, a, o, s = 0,
                l = this.length,
                c = 0 === arguments.length || "string" == typeof t && t;
            if (T.isFunction(t)) return this.each(function(e) {
                T(this).removeClass(t.call(this, e, this.className))
            });
            if (c)
                for (e = (t || "").match(D) || []; s < l; s++)
                    if (i = 1 === (n = this[s]).nodeType && (n.className ? (" " + n.className + " ").replace(Mt, " ") : "")) {
                        for (a = 0; r = e[a++];)
                            for (; 0 <= i.indexOf(" " + r + " ");) i = i.replace(" " + r + " ", " ");
                        o = t ? T.trim(i) : "", n.className !== o && (n.className = o)
                    }
            return this
        },
        toggleClass: function(r, t) {
            var a = typeof r;
            return "boolean" == typeof t && "string" == a ? t ? this.addClass(r) : this.removeClass(r) : this.each(T.isFunction(r) ? function(e) {
                T(this).toggleClass(r.call(this, e, this.className, t), t)
            } : function() {
                if ("string" == a)
                    for (var e, t = 0, n = T(this), i = r.match(D) || []; e = i[t++];) n.hasClass(e) ? n.removeClass(e) : n.addClass(e);
                else a !== q && "boolean" != a || (this.className && T._data(this, "__className__", this.className), this.className = this.className || !1 === r ? "" : T._data(this, "__className__") || "")
            })
        },
        hasClass: function(e) {
            for (var t = " " + e + " ", n = 0, i = this.length; n < i; n++)
                if (1 === this[n].nodeType && 0 <= (" " + this[n].className + " ").replace(Mt, " ").indexOf(t)) return !0;
            return !1
        }
    }), T.each("blur focus focusin focusout load resize scroll unload click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup error contextmenu".split(" "), function(e, n) {
        T.fn[n] = function(e, t) {
            return 0 < arguments.length ? this.on(n, null, e, t) : this.trigger(n)
        }
    }), T.fn.extend({
        hover: function(e, t) {
            return this.mouseenter(e).mouseleave(t || e)
        },
        bind: function(e, t, n) {
            return this.on(e, null, t, n)
        },
        unbind: function(e, t) {
            return this.off(e, null, t)
        },
        delegate: function(e, t, n, i) {
            return this.on(t, e, n, i)
        },
        undelegate: function(e, t, n) {
            return 1 === arguments.length ? this.off(e, "**") : this.off(t, e || "**", n)
        }
    });
    var Lt = T.now(),
        Ht = /\?/,
        qt = /(,)|(\[|{)|(}|])|"(?:[^"\\\r\n]|\\["\\\/bfnrt]|\\u[\da-fA-F]{4})*"\s*:?|true|false|null|-?(?!0\d)\d+(?:\.\d+|)(?:[eE][+-]?\d+|)/g;
    T.parseJSON = function(e) {
        if (h.JSON && h.JSON.parse) return h.JSON.parse(e + "");
        var r, a = null,
            t = T.trim(e + "");
        return t && !T.trim(t.replace(qt, function(e, t, n, i) {
            return r && t && (a = 0), 0 === a ? e : (r = n || t, a += !i - !n, "")
        })) ? Function("return " + t)() : T.error("Invalid JSON: " + e)
    }, T.parseXML = function(e) {
        var t;
        if (!e || "string" != typeof e) return null;
        try {
            h.DOMParser ? t = (new DOMParser).parseFromString(e, "text/xml") : ((t = new ActiveXObject("Microsoft.XMLDOM")).async = "false", t.loadXML(e))
        } catch (e) {
            t = void 0
        }
        return t && t.documentElement && !t.getElementsByTagName("parsererror").length || T.error("Invalid XML: " + e), t
    };
    var Wt, Pt, Ot = /#.*$/,
        Bt = /([?&])_=[^&]*/,
        Ft = /^(.*?):[ \t]*([^\r\n]*)\r?$/gm,
        zt = /^(?:GET|HEAD)$/,
        It = /^\/\//,
        Rt = /^([\w.+-]+:)(?:\/\/(?:[^\/?#]*@|)([^\/?#:]*)(?::(\d+)|)|)/,
        Xt = {},
        Vt = {},
        Yt = "*/".concat("*");
    try {
        Pt = location.href
    } catch (e) {
        (Pt = k.createElement("a")).href = "", Pt = Pt.href
    }

    function Ut(a) {
        return function(e, t) {
            "string" != typeof e && (t = e, e = "*");
            var n, i = 0,
                r = e.toLowerCase().match(D) || [];
            if (T.isFunction(t))
                for (; n = r[i++];) "+" === n.charAt(0) ? (n = n.slice(1) || "*", (a[n] = a[n] || []).unshift(t)) : (a[n] = a[n] || []).push(t)
        }
    }

    function Gt(t, r, a, o) {
        var s = {},
            l = t === Vt;

        function c(e) {
            var i;
            return s[e] = !0, T.each(t[e] || [], function(e, t) {
                var n = t(r, a, o);
                return "string" != typeof n || l || s[n] ? l ? !(i = n) : void 0 : (r.dataTypes.unshift(n), c(n), !1)
            }), i
        }
        return c(r.dataTypes[0]) || !s["*"] && c("*")
    }

    function Qt(e, t) {
        var n, i, r = T.ajaxSettings.flatOptions || {};
        for (i in t) void 0 !== t[i] && ((r[i] ? e : n = n || {})[i] = t[i]);
        return n && T.extend(!0, e, n), e
    }
    Wt = Rt.exec(Pt.toLowerCase()) || [], T.extend({
        active: 0,
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: Pt,
            type: "GET",
            isLocal: /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(Wt[1]),
            global: !0,
            processData: !0,
            async: !0,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            accepts: {
                "*": Yt,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /xml/,
                html: /html/,
                json: /json/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            converters: {
                "* text": String,
                "text html": !0,
                "text json": T.parseJSON,
                "text xml": T.parseXML
            },
            flatOptions: {
                url: !0,
                context: !0
            }
        },
        ajaxSetup: function(e, t) {
            return t ? Qt(Qt(e, T.ajaxSettings), t) : Qt(T.ajaxSettings, e)
        },
        ajaxPrefilter: Ut(Xt),
        ajaxTransport: Ut(Vt),
        ajax: function(e, t) {
            "object" == typeof e && (t = e, e = void 0), t = t || {};
            var n, i, d, u, p, f, h, r, m = T.ajaxSetup({}, t),
                g = m.context || m,
                v = m.context && (g.nodeType || g.jquery) ? T(g) : T.event,
                _ = T.Deferred(),
                y = T.Callbacks("once memory"),
                b = m.statusCode || {},
                a = {},
                o = {},
                x = 0,
                s = "canceled",
                w = {
                    readyState: 0,
                    getResponseHeader: function(e) {
                        var t;
                        if (2 === x) {
                            if (!r)
                                for (r = {}; t = Ft.exec(u);) r[t[1].toLowerCase()] = t[2];
                            t = r[e.toLowerCase()]
                        }
                        return null == t ? null : t
                    },
                    getAllResponseHeaders: function() {
                        return 2 === x ? u : null
                    },
                    setRequestHeader: function(e, t) {
                        var n = e.toLowerCase();
                        return x || (e = o[n] = o[n] || e, a[e] = t), this
                    },
                    overrideMimeType: function(e) {
                        return x || (m.mimeType = e), this
                    },
                    statusCode: function(e) {
                        var t;
                        if (e)
                            if (x < 2)
                                for (t in e) b[t] = [b[t], e[t]];
                            else w.always(e[w.status]);
                        return this
                    },
                    abort: function(e) {
                        var t = e || s;
                        return h && h.abort(t), l(0, t), this
                    }
                };
            if (_.promise(w).complete = y.add, w.success = w.done, w.error = w.fail, m.url = ((e || m.url || Pt) + "").replace(Ot, "").replace(It, Wt[1] + "//"), m.type = t.method || t.type || m.method || m.type, m.dataTypes = T.trim(m.dataType || "*").toLowerCase().match(D) || [""], null == m.crossDomain && (n = Rt.exec(m.url.toLowerCase()), m.crossDomain = !(!n || n[1] === Wt[1] && n[2] === Wt[2] && (n[3] || ("http:" === n[1] ? "80" : "443")) === (Wt[3] || ("http:" === Wt[1] ? "80" : "443")))), m.data && m.processData && "string" != typeof m.data && (m.data = T.param(m.data, m.traditional)), Gt(Xt, m, t, w), 2 === x) return w;
            for (i in (f = m.global) && 0 == T.active++ && T.event.trigger("ajaxStart"), m.type = m.type.toUpperCase(), m.hasContent = !zt.test(m.type), d = m.url, m.hasContent || (m.data && (d = m.url += (Ht.test(d) ? "&" : "?") + m.data, delete m.data), !1 === m.cache && (m.url = Bt.test(d) ? d.replace(Bt, "$1_=" + Lt++) : d + (Ht.test(d) ? "&" : "?") + "_=" + Lt++)), m.ifModified && (T.lastModified[d] && w.setRequestHeader("If-Modified-Since", T.lastModified[d]), T.etag[d] && w.setRequestHeader("If-None-Match", T.etag[d])), (m.data && m.hasContent && !1 !== m.contentType || t.contentType) && w.setRequestHeader("Content-Type", m.contentType), w.setRequestHeader("Accept", m.dataTypes[0] && m.accepts[m.dataTypes[0]] ? m.accepts[m.dataTypes[0]] + ("*" !== m.dataTypes[0] ? ", " + Yt + "; q=0.01" : "") : m.accepts["*"]), m.headers) w.setRequestHeader(i, m.headers[i]);
            if (m.beforeSend && (!1 === m.beforeSend.call(g, w, m) || 2 === x)) return w.abort();
            for (i in s = "abort", {
                success: 1,
                error: 1,
                complete: 1
            }) w[i](m[i]);
            if (h = Gt(Vt, m, t, w)) {
                w.readyState = 1, f && v.trigger("ajaxSend", [w, m]), m.async && 0 < m.timeout && (p = setTimeout(function() {
                    w.abort("timeout")
                }, m.timeout));
                try {
                    x = 1, h.send(a, l)
                } catch (e) {
                    if (!(x < 2)) throw e;
                    l(-1, e)
                }
            } else l(-1, "No Transport");

            function l(e, t, n, i) {
                var r, a, o, s, l, c = t;
                2 !== x && (x = 2, p && clearTimeout(p), h = void 0, u = i || "", w.readyState = 0 < e ? 4 : 0, r = 200 <= e && e < 300 || 304 === e, n && (s = function(e, t, n) {
                    for (var i, r, a, o, s = e.contents, l = e.dataTypes;
                         "*" === l[0];) l.shift(), void 0 === r && (r = e.mimeType || t.getResponseHeader("Content-Type"));
                    if (r)
                        for (o in s)
                            if (s[o] && s[o].test(r)) {
                                l.unshift(o);
                                break
                            }
                    if (l[0] in n) a = l[0];
                    else {
                        for (o in n) {
                            if (!l[0] || e.converters[o + " " + l[0]]) {
                                a = o;
                                break
                            }
                            i = i || o
                        }
                        a = a || i
                    }
                    return a ? (a !== l[0] && l.unshift(a), n[a]) : void 0
                }(m, w, n)), s = function(e, t, n, i) {
                    var r, a, o, s, l, c = {},
                        d = e.dataTypes.slice();
                    if (d[1])
                        for (o in e.converters) c[o.toLowerCase()] = e.converters[o];
                    for (a = d.shift(); a;)
                        if (e.responseFields[a] && (n[e.responseFields[a]] = t), !l && i && e.dataFilter && (t = e.dataFilter(t, e.dataType)), l = a, a = d.shift())
                            if ("*" === a) a = l;
                            else if ("*" !== l && l !== a) {
                                if (!(o = c[l + " " + a] || c["* " + a]))
                                    for (r in c)
                                        if ((s = r.split(" "))[1] === a && (o = c[l + " " + s[0]] || c["* " + s[0]])) {
                                            !0 === o ? o = c[r] : !0 !== c[r] && (a = s[0], d.unshift(s[1]));
                                            break
                                        }
                                if (!0 !== o)
                                    if (o && e.throws) t = o(t);
                                    else try {
                                        t = o(t)
                                    } catch (e) {
                                        return {
                                            state: "parsererror",
                                            error: o ? e : "No conversion from " + l + " to " + a
                                        }
                                    }
                            }
                    return {
                        state: "success",
                        data: t
                    }
                }(m, s, w, r), r ? (m.ifModified && ((l = w.getResponseHeader("Last-Modified")) && (T.lastModified[d] = l), (l = w.getResponseHeader("etag")) && (T.etag[d] = l)), 204 === e || "HEAD" === m.type ? c = "nocontent" : 304 === e ? c = "notmodified" : (c = s.state, a = s.data, r = !(o = s.error))) : (o = c, !e && c || (c = "error", e < 0 && (e = 0))), w.status = e, w.statusText = (t || c) + "", r ? _.resolveWith(g, [a, c, w]) : _.rejectWith(g, [w, c, o]), w.statusCode(b), b = void 0, f && v.trigger(r ? "ajaxSuccess" : "ajaxError", [w, m, r ? a : o]), y.fireWith(g, [w, c]), f && (v.trigger("ajaxComplete", [w, m]), --T.active || T.event.trigger("ajaxStop")))
            }
            return w
        },
        getJSON: function(e, t, n) {
            return T.get(e, t, n, "json")
        },
        getScript: function(e, t) {
            return T.get(e, void 0, t, "script")
        }
    }), T.each(["get", "post"], function(e, r) {
        T[r] = function(e, t, n, i) {
            return T.isFunction(t) && (i = i || n, n = t, t = void 0), T.ajax({
                url: e,
                type: r,
                dataType: i,
                data: t,
                success: n
            })
        }
    }), T.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function(e, t) {
        T.fn[t] = function(e) {
            return this.on(t, e)
        }
    }), T._evalUrl = function(e) {
        return T.ajax({
            url: e,
            type: "GET",
            dataType: "script",
            async: !1,
            global: !1,
            throws: !0
        })
    }, T.fn.extend({
        wrapAll: function(t) {
            if (T.isFunction(t)) return this.each(function(e) {
                T(this).wrapAll(t.call(this, e))
            });
            if (this[0]) {
                var e = T(t, this[0].ownerDocument).eq(0).clone(!0);
                this[0].parentNode && e.insertBefore(this[0]), e.map(function() {
                    for (var e = this; e.firstChild && 1 === e.firstChild.nodeType;) e = e.firstChild;
                    return e
                }).append(this)
            }
            return this
        },
        wrapInner: function(n) {
            return this.each(T.isFunction(n) ? function(e) {
                T(this).wrapInner(n.call(this, e))
            } : function() {
                var e = T(this),
                    t = e.contents();
                t.length ? t.wrapAll(n) : e.append(n)
            })
        },
        wrap: function(t) {
            var n = T.isFunction(t);
            return this.each(function(e) {
                T(this).wrapAll(n ? t.call(this, e) : t)
            })
        },
        unwrap: function() {
            return this.parent().each(function() {
                T.nodeName(this, "body") || T(this).replaceWith(this.childNodes)
            }).end()
        }
    }), T.expr.filters.hidden = function(e) {
        return e.offsetWidth <= 0 && e.offsetHeight <= 0 || !v.reliableHiddenOffsets() && "none" === (e.style && e.style.display || T.css(e, "display"))
    }, T.expr.filters.visible = function(e) {
        return !T.expr.filters.hidden(e)
    };
    var Jt = /%20/g,
        Kt = /\[\]$/,
        Zt = /\r?\n/g,
        en = /^(?:submit|button|image|reset|file)$/i,
        tn = /^(?:input|select|textarea|keygen)/i;

    function nn(n, e, i, r) {
        var t;
        if (T.isArray(e)) T.each(e, function(e, t) {
            i || Kt.test(n) ? r(n, t) : nn(n + "[" + ("object" == typeof t ? e : "") + "]", t, i, r)
        });
        else if (i || "object" !== T.type(e)) r(n, e);
        else
            for (t in e) nn(n + "[" + t + "]", e[t], i, r)
    }
    T.param = function(e, t) {
        function n(e, t) {
            t = T.isFunction(t) ? t() : null == t ? "" : t, r[r.length] = encodeURIComponent(e) + "=" + encodeURIComponent(t)
        }
        var i, r = [];
        if (void 0 === t && (t = T.ajaxSettings && T.ajaxSettings.traditional), T.isArray(e) || e.jquery && !T.isPlainObject(e)) T.each(e, function() {
            n(this.name, this.value)
        });
        else
            for (i in e) nn(i, e[i], t, n);
        return r.join("&").replace(Jt, "+")
    }, T.fn.extend({
        serialize: function() {
            return T.param(this.serializeArray())
        },
        serializeArray: function() {
            return this.map(function() {
                var e = T.prop(this, "elements");
                return e ? T.makeArray(e) : this
            }).filter(function() {
                var e = this.type;
                return this.name && !T(this).is(":disabled") && tn.test(this.nodeName) && !en.test(e) && (this.checked || !Y.test(e))
            }).map(function(e, t) {
                var n = T(this).val();
                return null == n ? null : T.isArray(n) ? T.map(n, function(e) {
                    return {
                        name: t.name,
                        value: e.replace(Zt, "\r\n")
                    }
                }) : {
                    name: t.name,
                    value: n.replace(Zt, "\r\n")
                }
            }).get()
        }
    }), T.ajaxSettings.xhr = void 0 !== h.ActiveXObject ? function() {
        return !this.isLocal && /^(get|post|head|put|delete|options)$/i.test(this.type) && sn() || function() {
            try {
                return new h.ActiveXObject("Microsoft.XMLHTTP")
            } catch (e) {}
        }()
    } : sn;
    var rn = 0,
        an = {},
        on = T.ajaxSettings.xhr();

    function sn() {
        try {
            return new h.XMLHttpRequest
        } catch (e) {}
    }
    h.ActiveXObject && T(h).on("unload", function() {
        for (var e in an) an[e](void 0, !0)
    }), v.cors = !!on && "withCredentials" in on, (on = v.ajax = !!on) && T.ajaxTransport(function(l) {
        var c;
        if (!l.crossDomain || v.cors) return {
            send: function(e, a) {
                var t, o = l.xhr(),
                    s = ++rn;
                if (o.open(l.type, l.url, l.async, l.username, l.password), l.xhrFields)
                    for (t in l.xhrFields) o[t] = l.xhrFields[t];
                for (t in l.mimeType && o.overrideMimeType && o.overrideMimeType(l.mimeType), l.crossDomain || e["X-Requested-With"] || (e["X-Requested-With"] = "XMLHttpRequest"), e) void 0 !== e[t] && o.setRequestHeader(t, e[t] + "");
                o.send(l.hasContent && l.data || null), c = function(e, t) {
                    var n, i, r;
                    if (c && (t || 4 === o.readyState))
                        if (delete an[s], c = void 0, o.onreadystatechange = T.noop, t) 4 !== o.readyState && o.abort();
                        else {
                            r = {}, n = o.status, "string" == typeof o.responseText && (r.text = o.responseText);
                            try {
                                i = o.statusText
                            } catch (e) {
                                i = ""
                            }
                            n || !l.isLocal || l.crossDomain ? 1223 === n && (n = 204) : n = r.text ? 200 : 404
                        }
                    r && a(n, i, r, o.getAllResponseHeaders())
                }, l.async ? 4 === o.readyState ? setTimeout(c) : o.onreadystatechange = an[s] = c : c()
            },
            abort: function() {
                c && c(void 0, !0)
            }
        }
    }), T.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /(?:java|ecma)script/
        },
        converters: {
            "text script": function(e) {
                return T.globalEval(e), e
            }
        }
    }), T.ajaxPrefilter("script", function(e) {
        void 0 === e.cache && (e.cache = !1), e.crossDomain && (e.type = "GET", e.global = !1)
    }), T.ajaxTransport("script", function(t) {
        if (t.crossDomain) {
            var i, r = k.head || T("head")[0] || k.documentElement;
            return {
                send: function(e, n) {
                    (i = k.createElement("script")).async = !0, t.scriptCharset && (i.charset = t.scriptCharset), i.src = t.url, i.onload = i.onreadystatechange = function(e, t) {
                        !t && i.readyState && !/loaded|complete/.test(i.readyState) || (i.onload = i.onreadystatechange = null, i.parentNode && i.parentNode.removeChild(i), i = null, t || n(200, "success"))
                    }, r.insertBefore(i, r.firstChild)
                },
                abort: function() {
                    i && i.onload(void 0, !0)
                }
            }
        }
    });
    var ln = [],
        cn = /(=)\?(?=&|$)|\?\?/;
    T.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function() {
            var e = ln.pop() || T.expando + "_" + Lt++;
            return this[e] = !0, e
        }
    }), T.ajaxPrefilter("json jsonp", function(e, t, n) {
        var i, r, a, o = !1 !== e.jsonp && (cn.test(e.url) ? "url" : "string" == typeof e.data && !(e.contentType || "").indexOf("application/x-www-form-urlencoded") && cn.test(e.data) && "data");
        return o || "jsonp" === e.dataTypes[0] ? (i = e.jsonpCallback = T.isFunction(e.jsonpCallback) ? e.jsonpCallback() : e.jsonpCallback, o ? e[o] = e[o].replace(cn, "$1" + i) : !1 !== e.jsonp && (e.url += (Ht.test(e.url) ? "&" : "?") + e.jsonp + "=" + i), e.converters["script json"] = function() {
            return a || T.error(i + " was not called"), a[0]
        }, e.dataTypes[0] = "json", r = h[i], h[i] = function() {
            a = arguments
        }, n.always(function() {
            h[i] = r, e[i] && (e.jsonpCallback = t.jsonpCallback, ln.push(i)), a && T.isFunction(r) && r(a[0]), a = r = void 0
        }), "script") : void 0
    }), T.parseHTML = function(e, t, n) {
        if (!e || "string" != typeof e) return null;
        "boolean" == typeof t && (n = t, t = !1), t = t || k;
        var i = b.exec(e),
            r = !n && [];
        return i ? [t.createElement(i[1])] : (i = T.buildFragment([e], t, r), r && r.length && T(r).remove(), T.merge([], i.childNodes))
    };
    var dn = T.fn.load;
    T.fn.load = function(e, t, n) {
        if ("string" != typeof e && dn) return dn.apply(this, arguments);
        var i, r, a, o = this,
            s = e.indexOf(" ");
        return 0 <= s && (i = e.slice(s, e.length), e = e.slice(0, s)), T.isFunction(t) ? (n = t, t = void 0) : t && "object" == typeof t && (a = "POST"), 0 < o.length && T.ajax({
            url: e,
            type: a,
            dataType: "html",
            data: t
        }).done(function(e) {
            r = arguments, o.html(i ? T("<div>").append(T.parseHTML(e)).find(i) : e)
        }).complete(n && function(e, t) {
            o.each(n, r || [e.responseText, t, e])
        }), this
    }, T.expr.filters.animated = function(t) {
        return T.grep(T.timers, function(e) {
            return t === e.elem
        }).length
    };
    var un = h.document.documentElement;

    function pn(e) {
        return T.isWindow(e) ? e : 9 === e.nodeType && (e.defaultView || e.parentWindow)
    }
    T.offset = {
        setOffset: function(e, t, n) {
            var i, r, a, o, s, l, c = T.css(e, "position"),
                d = T(e),
                u = {};
            "static" === c && (e.style.position = "relative"), s = d.offset(), a = T.css(e, "top"), l = T.css(e, "left"), r = ("absolute" === c || "fixed" === c) && -1 < T.inArray("auto", [a, l]) ? (o = (i = d.position()).top, i.left) : (o = parseFloat(a) || 0, parseFloat(l) || 0), T.isFunction(t) && (t = t.call(e, n, s)), null != t.top && (u.top = t.top - s.top + o), null != t.left && (u.left = t.left - s.left + r), "using" in t ? t.using.call(e, u) : d.css(u)
        }
    }, T.fn.extend({
        offset: function(t) {
            if (arguments.length) return void 0 === t ? this : this.each(function(e) {
                T.offset.setOffset(this, t, e)
            });
            var e, n, i = {
                    top: 0,
                    left: 0
                },
                r = this[0],
                a = r && r.ownerDocument;
            return a ? (e = a.documentElement, T.contains(e, r) ? (typeof r.getBoundingClientRect !== q && (i = r.getBoundingClientRect()), n = pn(a), {
                top: i.top + (n.pageYOffset || e.scrollTop) - (e.clientTop || 0),
                left: i.left + (n.pageXOffset || e.scrollLeft) - (e.clientLeft || 0)
            }) : i) : void 0
        },
        position: function() {
            if (this[0]) {
                var e, t, n = {
                        top: 0,
                        left: 0
                    },
                    i = this[0];
                return "fixed" === T.css(i, "position") ? t = i.getBoundingClientRect() : (e = this.offsetParent(), t = this.offset(), T.nodeName(e[0], "html") || (n = e.offset()), n.top += T.css(e[0], "borderTopWidth", !0), n.left += T.css(e[0], "borderLeftWidth", !0)), {
                    top: t.top - n.top - T.css(i, "marginTop", !0),
                    left: t.left - n.left - T.css(i, "marginLeft", !0)
                }
            }
        },
        offsetParent: function() {
            return this.map(function() {
                for (var e = this.offsetParent || un; e && !T.nodeName(e, "html") && "static" === T.css(e, "position");) e = e.offsetParent;
                return e || un
            })
        }
    }), T.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(t, r) {
        var a = /Y/.test(r);
        T.fn[t] = function(e) {
            return V(this, function(e, t, n) {
                var i = pn(e);
                return void 0 === n ? i ? r in i ? i[r] : i.document.documentElement[t] : e[t] : void(i ? i.scrollTo(a ? T(i).scrollLeft() : n, a ? n : T(i).scrollTop()) : e[t] = n)
            }, t, e, arguments.length, null)
        }
    }), T.each(["top", "left"], function(e, n) {
        T.cssHooks[n] = Ve(v.pixelPosition, function(e, t) {
            return t ? (t = Le(e, n), Re.test(t) ? T(e).position()[n] + "px" : t) : void 0
        })
    }), T.each({
        Height: "height",
        Width: "width"
    }, function(a, o) {
        T.each({
            padding: "inner" + a,
            content: o,
            "": "outer" + a
        }, function(i, e) {
            T.fn[e] = function(e, t) {
                var n = arguments.length && (i || "boolean" != typeof e),
                    r = i || (!0 === e || !0 === t ? "margin" : "border");
                return V(this, function(e, t, n) {
                    var i;
                    return T.isWindow(e) ? e.document.documentElement["client" + a] : 9 === e.nodeType ? (i = e.documentElement, Math.max(e.body["scroll" + a], i["scroll" + a], e.body["offset" + a], i["offset" + a], i["client" + a])) : void 0 === n ? T.css(e, t, r) : T.style(e, t, n, r)
                }, o, n ? e : void 0, n, null)
            }
        })
    }), T.fn.size = function() {
        return this.length
    }, T.fn.andSelf = T.fn.addBack, "function" == typeof define && define.amd && define("jquery", [], function() {
        return T
    });
    var fn = h.jQuery,
        hn = h.$;
    return T.noConflict = function(e) {
        return h.$ === T && (h.$ = hn), e && h.jQuery === T && (h.jQuery = fn), T
    }, typeof e === q && (h.jQuery = h.$ = T), T
});
for (var shop = "", scripts = document.getElementsByTagName("script"), i = 0, l = scripts.length; i < l; i++) null != scripts[i].getAttribute("data-id") && (shop = scripts[i].getAttribute("data-id"));

function function_call(e) {
    $.ajax({
        url: "https://www.theraptormedia.com/instagram/embed.php",
        data: {
            shop: e
        },
        dataType: "jsonp",
        jsonp: "raptormedia",
        async: "true",
        success: function(e) {
            var n = e.rep__insta__imgs;
            rep__insta__imgspopup = e.rep__insta__imgs;
            var i = e.links,
                r = e.likes,
                a = e.contents,
                o = e.commentcount,
                s = e.datelist,
                t = e.heading,
                l = e.overlay_color,
                c = e.font_color,
                d = e.no_of_img_in_slider,
                u = e.font_awesome,
                p = e.display_theme,
                f = (e.no_of_rows, e.slider_loop),
                h = e.no_of_img,
                m = e.gutter,
                g = e.video,
                v = e.img_hover,
                _ = e.show_lc,
                y = e.img_zoom_effect,
                b = e.custom_css,
                x = e.auto_play,
                w = e.no_popup,
                T = e.link_target,
                C = e.mobile,
                k = e.heading_color,
                E = e.font_size,
                N = e.img_radius,
                S = e.width,
                A = e.margin,
                D = (e.marginslider, e.sliderwidth, e.username),
                j = e.profile_pic,
                M = e.provider,
                L = e.insta_link,
                H = e.overlay_opacity;
            $("#rap__med__instagram").prepend('<div id="rap__med__insta_title"><h2><a href="' + L + '" target="_blank" style="padding: 0 0 20px;text-align:center;float:left;width:100%;color:' + k + ";font-size:" + E + ';" > ' + t + " </a></h2></div>"), $("#rap__med__instagram").append("<div id='rap__med__insta'></div>"), "no" == w && $("#rap__med__instagram").append("<div class='rap__med__insta__popup'></div>");
            var q = $("#rap__med__instagram").width();
            q = parseInt(q);
            var W = (q -= 10) / h;
            W = parseInt(W);
            $("<style>#rap__med__insta-img{height:" + W + "px;}</style>").appendTo("body"), $("#rap__med__insta-img, .rap__med__wrap__inside").css("height", W + "px"), x = "true" == x, f = "true" == f, "slider" == p && (function(C) {
                "use strict";
                var i = {
                    item: d,
                    autoWidth: !1,
                    slideMove: 1,
                    slideMargin: 10,
                    addClass: "",
                    mode: "slide",
                    useCSS: !0,
                    cssEasing: "ease",
                    easing: "linear",
                    speed: 2e3,
                    auto: !1,
                    pauseOnHover: !1,
                    loop: !1,
                    slideEndAnimation: !0,
                    pause: 2e3,
                    keyPress: !1,
                    controls: !0,
                    prevHtml: "",
                    nextHtml: "",
                    rtl: !1,
                    adaptiveHeight: !1,
                    vertical: !1,
                    verticalHeight: 500,
                    vThumbWidth: 100,
                    thumbItem: 10,
                    pager: !0,
                    gallery: !1,
                    galleryMargin: 5,
                    thumbMargin: 2,
                    currentPagerPosition: "middle",
                    enableTouch: !0,
                    enableDrag: !0,
                    freeMove: !0,
                    swipeThreshold: 40,
                    responsive: [],
                    onBeforeStart: function(e) {},
                    onSliderLoad: function(e) {},
                    onBeforeSlide: function(e, t) {},
                    onAfterSlide: function(e, t) {},
                    onBeforeNextSlide: function(e, t) {},
                    onBeforePrevSlide: function(e, t) {}
                };
                C.fn.rap__med__slider = function(e) {
                    if (0 === this.length) return this;
                    if (1 < this.length) return this.each(function() {
                        C(this).rap__med__slider(e)
                    }), this;
                    var n = {},
                        d = C.extend(!0, {}, i, e),
                        r = {},
                        u = this;
                    n.$el = this, "fade" === d.mode && (d.vertical = !1);
                    var c = u.children(),
                        a = C(window).width(),
                        o = null,
                        s = 0,
                        p = 0,
                        t = !1,
                        f = 0,
                        h = "",
                        m = 0,
                        g = !0 === d.vertical ? "height" : "width",
                        v = !0 === d.vertical ? "margin-bottom" : "margin-right",
                        _ = 0,
                        y = 0,
                        b = 0,
                        x = 0,
                        l = null,
                        w = "ontouchstart" in document.documentElement,
                        T = {
                            chbreakpoint: function() {
                                if (a = C(window).width(), d.responsive.length) {
                                    var e;
                                    if (!1 === d.autoWidth && (e = d.item), a < d.responsive[0].breakpoint)
                                        for (var t = 0; t < d.responsive.length; t++) a < d.responsive[t].breakpoint && (d.responsive[t].breakpoint, o = d.responsive[t]);
                                    if (null != o)
                                        for (var n in o.settings) o.settings.hasOwnProperty(n) && (void 0 !== r[n] && null !== r[n] || (r[n] = d[n]), d[n] = o.settings[n]);
                                    if (!C.isEmptyObject(r) && a > d.responsive[0].breakpoint)
                                        for (var i in r) r.hasOwnProperty(i) && (d[i] = r[i]);
                                    !1 === d.autoWidth && 0 < _ && 0 < b && e !== d.item && (m = Math.round(_ / ((b + d.slideMargin) * d.slideMove)))
                                }
                            },
                            calSW: function() {
                                !1 === d.autoWidth && (b = (f - (d.item * d.slideMargin - d.slideMargin)) / d.item)
                            },
                            calWidth: function(e) {
                                var t = !0 === e ? h.find(".lslide").length : c.length;
                                if (!1 === d.autoWidth) p = t * (b + d.slideMargin);
                                else
                                    for (var n = p = 0; n < t; n++) p += parseInt(c.eq(n).width()) + d.slideMargin;
                                return p
                            }
                        };
                    return (n = {
                        doCss: function() {
                            return !(!d.useCSS || ! function() {
                                for (var e = ["transition", "MozTransition", "WebkitTransition", "OTransition", "msTransition", "KhtmlTransition"], t = document.documentElement, n = 0; n < e.length; n++)
                                    if (e[n] in t.style) return !0
                            }())
                        },
                        keyPress: function() {
                            d.keyPress && C(document).on("keyup.rap__med__slider", function(e) {
                                C(":focus").is("input, textarea") || (e.preventDefault ? e.preventDefault() : e.returnValue = !1, 37 === e.keyCode ? u.goToPrevSlide() : 39 === e.keyCode && u.goToNextSlide())
                            })
                        },
                        controls: function() {
                            d.controls && (u.after('<div class="rap__med__action"><a class="rap__med__prev">' + d.prevHtml + '</a><a class="rap__med__next">' + d.nextHtml + "</a></div>"), d.autoWidth ? T.calWidth(!1) < f && h.find(".rap__med__action").hide() : s <= d.item && h.find(".rap__med__action").hide(), h.find(".rap__med__action a").on("click", function(e) {
                                return e.preventDefault ? e.preventDefault() : e.returnValue = !1, "rap__med__prev" === C(this).attr("class") ? u.goToPrevSlide() : u.goToNextSlide(), !1
                            }))
                        },
                        initialStyle: function() {
                            var l = this;
                            "fade" === d.mode && (d.autoWidth = !1, d.slideEndAnimation = !1), d.auto && (d.slideEndAnimation = !1), d.autoWidth && (d.slideMove = 1, d.item = 1), d.loop && (d.slideMove = 1, d.freeMove = !1), d.onBeforeStart.call(this, u), T.chbreakpoint(), u.addClass("rap__med__slider").wrap('<div class="rap__med__sliderOuter ' + d.addClass + '"><div class="rap__med__sliderWrapper"></div></div>'), h = u.parent(".rap__med__sliderWrapper"), !0 === d.rtl && h.parent().addClass("lSrtl"), d.vertical ? (h.parent().addClass("vertical"), f = d.verticalHeight, h.css("height", f + "px")) : f = u.outerWidth(), c.addClass("lslide"), !0 === d.loop && "slide" === d.mode && (T.calSW(), T.clone = function() {
                                if (T.calWidth(!0) > f) {
                                    for (var e = 0, t = 0, n = 0; n < c.length && (t++, !((e += parseInt(u.find(".lslide").eq(n).width()) + d.slideMargin) >= f + d.slideMargin)); n++);
                                    var i = !0 === d.autoWidth ? t : d.item;
                                    if (i < u.find(".clone.left").length)
                                        for (var r = 0; r < u.find(".clone.left").length - i; r++) c.eq(r).remove();
                                    if (i < u.find(".clone.right").length)
                                        for (var a = c.length - 1; a > c.length - 1 - u.find(".clone.right").length; a--) m--, c.eq(a).remove();
                                    for (var o = u.find(".clone.right").length; o < i; o++) u.find(".lslide").eq(o).clone().removeClass("lslide").addClass("clone right").appendTo(u), m++;
                                    for (var s = u.find(".lslide").length - u.find(".clone.left").length; s > u.find(".lslide").length - i; s--) u.find(".lslide").eq(s - 1).clone().removeClass("lslide").addClass("clone left").prependTo(u);
                                    c = u.children()
                                } else c.hasClass("clone") && (u.find(".clone").remove(), l.move(u, 0))
                            }, T.clone()), T.sSW = function() {
                                if (s = c.length, !0 === d.rtl && !1 === d.vertical && (v = "margin-left"), !1 === d.autoWidth) {
                                    c.css(g, b + "px");
                                    C("#rap__med__instabox").width();
                                    C(".rap__med__insta-img").css("height", b + "px")
                                }
                                c.css(v, d.slideMargin + "px"), p = T.calWidth(!1), u.css(g, p + "px"), !0 === d.loop && "slide" === d.mode && !1 === t && (m = u.find(".clone.left").length)
                            }, T.calL = function() {
                                c = u.children(), s = c.length
                            }, this.doCss() && h.addClass("usingCss"), T.calL(), "slide" === d.mode ? (T.calSW(), T.sSW(), !0 === d.loop && (_ = l.slideValue(), this.move(u, _)), !1 === d.vertical && this.setHeight(u, !1)) : (this.setHeight(u, !0), u.addClass("rap__med__fade"), this.doCss() || (c.fadeOut(0), c.eq(m).fadeIn(0))), !0 === d.loop && "slide" === d.mode ? c.eq(m).addClass("active") : c.first().addClass("active")
                        },
                        pager: function() {
                            var c = this;
                            if (T.createPager = function() {
                                x = (f - (d.thumbItem * d.thumbMargin - d.thumbMargin)) / d.thumbItem;
                                var e = h.find(".lslide"),
                                    t = h.find(".lslide").length,
                                    n = 0,
                                    i = "",
                                    r = 0;
                                for (n = 0; n < t; n++) {
                                    "slide" === d.mode && (d.autoWidth ? r += (parseInt(e.eq(n).width()) + d.slideMargin) * d.slideMove : r = n * ((b + d.slideMargin) * d.slideMove));
                                    var a = e.eq(n * d.slideMove).attr("data-thumb");
                                    if (!0 === d.gallery ? i += '<li style="width:100%;' + g + ":" + x + "px;" + v + ":" + d.thumbMargin + 'px"><a href="#"><img src="' + a + '" /></a></li>' : i += '<li><a href="#">' + (n + 1) + "</a></li>", "slide" === d.mode && r >= p - f - d.slideMargin) {
                                        n += 1;
                                        var o = 2;
                                        d.autoWidth && (i += '<li><a href="#">' + (n + 1) + "</a></li>", o = 1), n < o ? (i = null, h.parent().addClass("noPager")) : h.parent().removeClass("noPager");
                                        break
                                    }
                                }
                                var s = h.parent();
                                s.find(".rap__med__pager").html(i), !0 === d.gallery && (!0 === d.vertical && s.find(".rap__med__pager").css("width", d.vThumbWidth + "px"), y = n * (d.thumbMargin + x) + .5, s.find(".rap__med__pager").css({
                                    property: y + "px",
                                    "transition-duration": d.speed + "ms"
                                }), !0 === d.vertical && h.parent().css("padding-right", d.vThumbWidth + d.galleryMargin + "px"), s.find(".rap__med__pager").css(g, y + "px"));
                                var l = s.find(".rap__med__pager").find("li");
                                l.first().addClass("active"), l.on("click", function() {
                                    return !0 === d.loop && "slide" === d.mode ? m += l.index(this) - s.find(".rap__med__pager").find("li.active").index() : m = l.index(this), u.mode(!1), !0 === d.gallery && c.slideThumb(), !1
                                })
                            }, d.pager) {
                                var e = "rap__med__pg";
                                d.gallery && (e = "rap__med__gallery"), h.after('<ul class="rap__med__pager ' + e + '"></ul>');
                                var t = d.vertical ? "margin-left" : "margin-top";
                                h.parent().find(".rap__med__pager").css(t, d.galleryMargin + "px"), T.createPager()
                            }
                            setTimeout(function() {
                                T.init()
                            }, 0)
                        },
                        setHeight: function(i, r) {
                            var a = null,
                                e = this;
                            a = d.loop ? i.children(".lslide ").first() : i.children().first();

                            function t() {
                                var e = a.outerHeight(),
                                    t = 0,
                                    n = e;
                                r && (e = 0, t = 100 * n / f), i.css({
                                    height: e + "px",
                                    "padding-bottom": t + "%"
                                })
                            }
                            t(), a.find("img").length ? a.find("img")[0].complete ? (t(), l || e.auto()) : a.find("img").load(function() {
                                setTimeout(function() {
                                    t(), l || e.auto()
                                }, 100)
                            }) : l || e.auto()
                        },
                        active: function(e, t) {
                            this.doCss() && "fade" === d.mode && h.addClass("on");
                            var n, i, r = 0;
                            m * d.slideMove < s ? (e.removeClass("active"), this.doCss() || "fade" !== d.mode || !1 !== t || e.fadeOut(d.speed), r = !0 === t ? m : m * d.slideMove, !0 === t && (i = (n = e.length) - 1, n <= r + 1 && (r = i)), !0 === d.loop && "slide" === d.mode && (r = !0 === t ? m - u.find(".clone.left").length : m * d.slideMove, !0 === t && (i = (n = e.length) - 1, r + 1 === n ? r = i : n < r + 1 && (r = 0))), this.doCss() || "fade" !== d.mode || !1 !== t || e.eq(r).fadeIn(d.speed), e.eq(r).addClass("active")) : (e.removeClass("active"), e.eq(e.length - 1).addClass("active"), this.doCss() || "fade" !== d.mode || !1 !== t || (e.fadeOut(d.speed), e.eq(r).fadeIn(d.speed)))
                        },
                        move: function(e, t) {
                            !0 === d.rtl && (t = -t), this.doCss() ? !0 === d.vertical ? e.css({
                                transform: "translate3d(0px, " + -t + "px, 0px)",
                                "-webkit-transform": "translate3d(0px, " + -t + "px, 0px)"
                            }) : e.css({
                                transform: "translate3d(" + -t + "px, 0px, 0px)",
                                "-webkit-transform": "translate3d(" + -t + "px, 0px, 0px)"
                            }) : !0 === d.vertical ? e.css("position", "relative").animate({
                                top: -t + "px"
                            }, d.speed, d.easing) : e.css("position", "relative").animate({
                                left: -t + "px"
                            }, d.speed, d.easing);
                            var n = h.parent().find(".rap__med__pager").find("li");
                            this.active(n, !0)
                        },
                        fade: function() {
                            this.active(c, !1);
                            var e = h.parent().find(".rap__med__pager").find("li");
                            this.active(e, !0)
                        },
                        slide: function() {
                            var e = this;
                            T.calSlide = function() {
                                f < p && (_ = e.slideValue(), e.active(c, !1), _ > p - f - d.slideMargin ? _ = p - f - d.slideMargin : _ < 0 && (_ = 0), e.move(u, _), !0 === d.loop && "slide" === d.mode && (m >= s - u.find(".clone.left").length / d.slideMove && e.resetSlide(u.find(".clone.left").length), 0 === m && e.resetSlide(h.find(".lslide").length)))
                            }, T.calSlide()
                        },
                        resetSlide: function(e) {
                            var t = this;
                            h.find(".rap__med__action a").addClass(""), setTimeout(function() {
                                m = e, h.css("transition-duration", "0ms"), _ = t.slideValue(), t.active(c, !1), n.move(u, _), setTimeout(function() {
                                    h.css("transition-duration", d.speed + "ms"), h.find(".rap__med__action a").removeClass("")
                                }, 50)
                            }, d.speed + 100)
                        },
                        slideValue: function() {
                            var e = 0;
                            if (!1 === d.autoWidth) e = m * ((b + d.slideMargin) * d.slideMove);
                            else
                                for (var t = e = 0; t < m; t++) e += parseInt(c.eq(t).width()) + d.slideMargin;
                            return e
                        },
                        slideThumb: function() {
                            var e;
                            switch (d.currentPagerPosition) {
                                case "left":
                                    e = 0;
                                    break;
                                case "middle":
                                    e = f / 2 - x / 2;
                                    break;
                                case "right":
                                    e = f - x
                            }
                            var t = m - u.find(".clone.left").length,
                                n = h.parent().find(".rap__med__pager");
                            "slide" === d.mode && !0 === d.loop && (t >= n.children().length ? t = 0 : t < 0 && (t = n.children().length));
                            var i = t * (x + d.thumbMargin) - e;
                            y < i + f && (i = y - f - d.thumbMargin), i < 0 && (i = 0), this.move(n, i)
                        },
                        auto: function() {
                            d.auto && (clearInterval(l), l = setInterval(function() {
                                u.goToNextSlide()
                            }, d.pause))
                        },
                        pauseOnHover: function() {
                            var e = this;
                            d.auto && d.pauseOnHover && (h.on("mouseenter", function() {
                                C(this).addClass("ls-hover"), u.pause(), d.auto = !0
                            }), h.on("mouseleave", function() {
                                C(this).removeClass("ls-hover"), h.find(".rap__med__slider").hasClass("lsGrabbing") || e.auto()
                            }))
                        },
                        touchMove: function(e, t) {
                            if (h.css("transition-duration", "0ms"), "slide" === d.mode) {
                                var n = _ - (e - t);
                                if (n >= p - f - d.slideMargin)
                                    if (!1 === d.freeMove) n = p - f - d.slideMargin;
                                    else {
                                        var i = p - f - d.slideMargin;
                                        n = i + (n - i) / 5
                                    } else n < 0 && (!1 === d.freeMove ? n = 0 : n /= 5);
                                this.move(u, n)
                            }
                        },
                        touchEnd: function(e) {
                            if (h.css("transition-duration", d.speed + "ms"), "slide" === d.mode) {
                                var a = !1,
                                    t = !0;
                                (_ -= e) > p - f - d.slideMargin ? (_ = p - f - d.slideMargin, !1 === d.autoWidth && (a = !0)) : _ < 0 && (_ = 0);
                                var n = function(e) {
                                    var t = 0;
                                    if (a || e && (t = 1), d.autoWidth)
                                        for (var n = 0, i = 0; i < c.length && (n += parseInt(c.eq(i).width()) + d.slideMargin, m = i + t, !(_ <= n)); i++);
                                    else {
                                        var r = _ / ((b + d.slideMargin) * d.slideMove);
                                        m = parseInt(r) + t, _ >= p - f - d.slideMargin && r % 1 != 0 && m++
                                    }
                                };
                                e >= d.swipeThreshold ? (n(!1), t = !1) : e <= -d.swipeThreshold && (n(!0), t = !1), u.mode(t), this.slideThumb()
                            } else e >= d.swipeThreshold ? u.goToPrevSlide() : e <= -d.swipeThreshold && u.goToNextSlide()
                        },
                        enableDrag: function() {
                            var n = this;
                            if (!w) {
                                var i = 0,
                                    r = 0,
                                    a = !1;
                                h.find(".rap__med__slider").addClass("lsGrab"), h.on("mousedown", function(e) {
                                    if (p < f && 0 !== p) return !1;
                                    "rap__med__prev" !== C(e.target).attr("class") && "rap__med__next" !== C(e.target).attr("class") && (i = !0 === d.vertical ? e.pageY : e.pageX, a = !0, e.preventDefault ? e.preventDefault() : e.returnValue = !1, h.scrollLeft += 1, --h.scrollLeft, h.find(".rap__med__slider").removeClass("lsGrab").addClass("lsGrabbing"), clearInterval(l))
                                }), C(window).on("mousemove", function(e) {
                                    a && (r = !0 === d.vertical ? e.pageY : e.pageX, n.touchMove(r, i))
                                }), C(window).on("mouseup", function(e) {
                                    if (a) {
                                        h.find(".rap__med__slider").removeClass("lsGrabbing").addClass("lsGrab");
                                        var t = (r = !(a = !1) === d.vertical ? e.pageY : e.pageX) - i;
                                        Math.abs(t) >= d.swipeThreshold && C(window).on("click.ls", function(e) {
                                            e.preventDefault ? e.preventDefault() : e.returnValue = !1, e.stopImmediatePropagation(), e.stopPropagation(), C(window).off("click.ls")
                                        }), n.touchEnd(t)
                                    }
                                })
                            }
                        },
                        enableTouch: function() {
                            var r = this;
                            if (w) {
                                var a = {},
                                    o = {};
                                h.on("touchstart", function(e) {
                                    o = e.originalEvent.targetTouches[0], a.pageX = e.originalEvent.targetTouches[0].pageX, a.pageY = e.originalEvent.targetTouches[0].pageY, clearInterval(l)
                                }), h.on("touchmove", function(e) {
                                    if (p < f && 0 !== p) return !1;
                                    var t = e.originalEvent;
                                    o = t.targetTouches[0];
                                    var n = Math.abs(o.pageX - a.pageX),
                                        i = Math.abs(o.pageY - a.pageY);
                                    !0 === d.vertical ? (n < 3 * i && e.preventDefault(), r.touchMove(o.pageY, a.pageY)) : (i < 3 * n && e.preventDefault(), r.touchMove(o.pageX, a.pageX))
                                }), h.on("touchend", function() {
                                    if (p < f && 0 !== p) return !1;
                                    var e;
                                    e = !0 === d.vertical ? o.pageY - a.pageY : o.pageX - a.pageX, r.touchEnd(e)
                                })
                            }
                        },
                        build: function() {
                            var e = this;
                            e.initialStyle(), this.doCss() && (!0 === d.enableTouch && e.enableTouch(), !0 === d.enableDrag && e.enableDrag()), C(window).on("focus", function() {
                                e.auto()
                            }), C(window).on("blur", function() {
                                clearInterval(l)
                            }), e.pager(), e.pauseOnHover(), e.controls(), e.keyPress()
                        }
                    }).build(), T.init = function() {
                        T.chbreakpoint(), !0 === d.vertical ? (f = 1 < d.item ? d.verticalHeight : c.outerHeight(), h.css("height", f + "px")) : f = h.outerWidth(), !0 === d.loop && "slide" === d.mode && T.clone(), T.calL(), "slide" === d.mode && u.removeClass("rap__med__slide"), "slide" === d.mode && (T.calSW(), T.sSW()), setTimeout(function() {
                            "slide" === d.mode && u.addClass("rap__med__slide")
                        }, 1e3), d.pager && T.createPager(), !0 === d.adaptiveHeight && !1 === d.vertical && u.css("height", c.eq(m).outerHeight(!0)), !1 === d.adaptiveHeight && ("slide" === d.mode ? !1 === d.vertical ? n.setHeight(u, !1) : n.auto() : n.setHeight(u, !0)), !0 === d.gallery && n.slideThumb(), "slide" === d.mode && n.slide(), !1 === d.autoWidth ? c.length <= d.item ? h.find(".rap__med__action").hide() : h.find(".rap__med__action").show() : T.calWidth(!1) < f && 0 !== p ? h.find(".rap__med__action").hide() : h.find(".rap__med__action").show()
                    }, u.goToPrevSlide = function() {
                        if (0 < m) d.onBeforePrevSlide.call(this, u, m), m--, u.mode(!1), !0 === d.gallery && n.slideThumb();
                        else if (!0 === d.loop) {
                            if (d.onBeforePrevSlide.call(this, u, m), "fade" === d.mode) m = parseInt((s - 1) / d.slideMove);
                            u.mode(!1), !0 === d.gallery && n.slideThumb()
                        } else !0 === d.slideEndAnimation && (u.addClass("leftEnd"), setTimeout(function() {
                            u.removeClass("leftEnd")
                        }, 400))
                    }, u.goToNextSlide = function() {
                        var e = !0;
                        "slide" === d.mode && (e = n.slideValue() < p - f - d.slideMargin);
                        m * d.slideMove < s - d.slideMove && e ? (d.onBeforeNextSlide.call(this, u, m), m++, u.mode(!1), !0 === d.gallery && n.slideThumb()) : !0 === d.loop ? (d.onBeforeNextSlide.call(this, u, m), m = 0, u.mode(!1), !0 === d.gallery && n.slideThumb()) : !0 === d.slideEndAnimation && (u.addClass("rightEnd"), setTimeout(function() {
                            u.removeClass("rightEnd")
                        }, 400))
                    }, u.mode = function(e) {
                        !0 === d.adaptiveHeight && !1 === d.vertical && u.css("height", c.eq(m).outerHeight(!0)), !1 === t && ("slide" === d.mode ? n.doCss() && (u.addClass("rap__med__slide"), "" !== d.speed && h.css("transition-duration", d.speed + "ms"), "" !== d.cssEasing && h.css("transition-timing-function", d.cssEasing)) : n.doCss() && ("" !== d.speed && u.css("transition-duration", d.speed + "ms"), "" !== d.cssEasing && u.css("transition-timing-function", d.cssEasing))), e || d.onBeforeSlide.call(this, u, m), "slide" === d.mode ? n.slide() : n.fade(), h.hasClass("ls-hover") || n.auto(), setTimeout(function() {
                            e || d.onAfterSlide.call(this, u, m)
                        }, d.speed), t = !0
                    }, u.play = function() {
                        u.goToNextSlide(), d.auto = !0, n.auto()
                    }, u.pause = function() {
                        d.auto = !1, clearInterval(l)
                    }, u.refresh = function() {
                        T.init()
                    }, u.getCurrentSlideCount = function() {
                        var e = m;
                        if (d.loop) {
                            var t = h.find(".lslide").length,
                                n = u.find(".clone.left").length;
                            e = m <= n - 1 ? t + (m - n) : t + n <= m ? m - t - n : m - n
                        }
                        return e + 1
                    }, u.getTotalSlideCount = function() {
                        return h.find(".lslide").length
                    }, u.goToSlide = function(e) {
                        m = d.loop ? e + u.find(".clone.left").length - 1 : e, u.mode(!1), !0 === d.gallery && n.slideThumb()
                    }, u.destroy = function() {
                        u.rap__med__slider && (u.goToPrevSlide = function() {}, u.goToNextSlide = function() {}, u.mode = function() {}, u.play = function() {}, u.pause = function() {}, u.refresh = function() {}, u.getCurrentSlideCount = function() {}, u.getTotalSlideCount = function() {}, u.goToSlide = function() {}, u.rap__med__slider = null, T = {
                            init: function() {}
                        }, u.parent().parent().find(".rap__med__action, .rap__med__pager").remove(), u.removeClass("rap__med__slider rap__med__fade rap__med__slide lsGrab lsGrabbing leftEnd right").removeAttr("style").unwrap().unwrap(), u.children().removeAttr("style"), c.removeClass("lslide active"), u.find(".clone").remove(), l = c = null, t = !1, m = 0)
                    }, setTimeout(function() {
                        d.onSliderLoad.call(this, u)
                    }, 10), C(window).on("resize orientationchange", function(e) {
                        setTimeout(function() {
                            e.preventDefault ? e.preventDefault() : e.returnValue = !1, T.init()
                        }, 200)
                    }), this
                }
            }(jQuery), $(document).ready(function() {
                $("#rap__med__insta").rap__med__slider({
                    addClass: "",
                    mode: "slide",
                    useCSS: !0,
                    cssEasing: "ease",
                    easing: "linear",
                    speed: 2e3,
                    auto: x,
                    loop: f,
                    pauseOnHover: !0,
                    slideEndAnimation: !1,
                    pause: 3e3,
                    responsive: [{
                        breakpoint: 800,
                        settings: {
                            item: 3,
                            slideMove: 1,
                            slideMargin: 6
                        }
                    }, {
                        breakpoint: 480,
                        settings: {
                            item: 1,
                            slideMove: 1
                        }
                    }]
                })
            })), jQuery(document).ready(function() {
                $('<link rel="stylesheet" type="text/css" href="https://www.theraptormedia.com/instagram/instagram.css">').appendTo("body"), "new" == u && $('<script src="https://kit.fontawesome.com/a076d05399.js"><\/script>').appendTo("body"), "old" == u && $('<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">').appendTo("body"), "true" == y && $("<style>#rap__med__instabox .rap__med__wrap__inside:hover .rap__med__insta-img, #rap__med__instabox .rap__med__wrap__inside:hover img { transform: scale(1.1);transition: all 1.5s ease; }</style>").appendTo("body"), $("<style>.rap__med__wrap__inside img{width:100%;height:auto; max-width:100%;float:left; border-radius:" + N + ";}.rap__med__overlay-hover img{float:none;max-width:100%;width:40px; height:auto; border-radius:40px;}.rap__med__instaboxtext{width:100%; box-sizing:border-box; padding: 0 10px;}</style>").appendTo("body"), 1023 < screen.width && $("<style>.sticky .navbar-default.navbar-fixed-top.sticky{transform:none;}#PageContainer{transform:none;-webkit-transform:none; will-change: inherit;}</style>").appendTo("body"), "slider" == p && (m = 0), "grid" == p && ($("<style>@media screen and (max-width: 736px){#rap__med__instabox{width:33.33%!important;}}</style>").appendTo("body"), $("<style>@media screen and (max-width: 478px){#rap__med__instabox{width:50%!important;}}</style>").appendTo("body")), $("<style>.rap__med__wrap__inside::before{background:rgba(" + l + ", " + H + " )!important;border-radius:" + N + ";}</style>").appendTo("body"), "no_overlay" == v && $("<style>.rap__med__wrap__inside::before{background:none!important; position:unset;}</style>").appendTo("body"), "bw_layout" == v && $("<style>.rap__med__wrap__inside::before{background:none!important; position:unset;}#rap__med__insta-img { filter: grayscale(1); }#rap__med__instabox :hover #rap__med__insta-img { filter: grayscale(0);  }</style>").appendTo("body"), "caption" == v && $("<style>.rp_caption_bottom span { padding: 2px; font-weight: normal; }.rp_caption_bottom span .fa, .rp_caption_bottom span .far { padding: 2px; }.rp_caption_bottom { position: absolute; bottom: 0; right: 10px; }.rap__med__overlay-top { position: relative; top: 0; float: left; width: 100%; height:100%; text-align: left; padding: 10px; box-sizing: border-box; color:" + c + ";}</style>").appendTo("body"), "caption1" == v && $("<style>.rp_caption_bottom span { padding: 2px; font-weight: normal; }.rp_caption_bottom span .fa, .rp_caption_bottom span .far { padding: 2px; }.insta_date { position: absolute; bottom: 10px; }.rap_large_caption, .insta_date { font-size: 14px; }.rap__med__insta_overlay{text-align:left; box-sizing: border-box; padding: 15px;}.rp_caption_bottom { float: left; width: 100%; padding-bottom: 10px; }</style>").appendTo("body"), $("<style>.rap__med__overlay-top, .rap_large_caption,.rap_small_caption{color:" + c + ";}</style>").appendTo("body"), $("<style>.rp_lc span { padding: 2px; font-weight: normal; }.rp_lc span .fa, .rp_lc span .far { padding: 2px; }.rp_lc .fa-comment { font-size: 15px; }</style>").appendTo("body"), "show_lc" == _ ? $("<style>.rp_lc {display:block; }</style>").appendTo("body") : $("<style>.rp_lc {display:none; }</style>").appendTo("body"), $("<style>#rap__med__instabox {float:left;list-style:none;overflow: hidden;width:" + S + "%;margin:" + A + "%;padding:" + m + "; }</style>").appendTo("body"), "instagram" == M && $("<style>.insta-likes, .insta-comments, .insta-link{display:none;}</style>").appendTo("body"), $(document).ready(function() {
                    $.each(n, function(e, t) {
                        $("#rap__med__insta").append("<div id='rap__med__insta-img' class='rap__med__insta-img' style='background:url(" + n[e] + ") no-repeat center center/cover;'></div>")
                    }), $("#rap__med__insta #rap__med__insta-img").each(function(e, t) {
                        $(this).wrap("<a id='rap__med__onclick__" + [e] + "' class='rap__med__wrap__inside'  style='float:left;width:100%;'  ></a>"), "yes" == w && ($("#rap__med__onclick__" + e).attr("href", i[e]), $("#rap__med__onclick__" + e).attr("target", T)), "bw_layout" != v && "no_overlay" != v || $("#rap__med__onclick__" + e).attr("title", a[e])
                    }), $("#rap__med__insta .rap__med__wrap__inside").each(function(e, t) {
                        $(this).wrap("<div id='rap__med__instabox'></div>")
                    }), $("#rap__med__insta .rap__med__wrap__inside").each(function(e, t) {
                        $(this).append("<div class='rap__med__insta_overlay'></div>")
                    }), $("#rap__med__insta .rap__med__wrap__inside .rap__med__insta_overlay").each(function(e, t) {
                        if ("insta_icon" == v && ("instagram" == M && $(this).append("<div class='rap__med__overlay-hover'><i class='fab fa-instagram' style='color:" + c + "!important;font-size:30px;'></i></div>"), "facebook" == M && $(this).append("<div class='rap__med__overlay-hover'><i class='fab fa-instagram' style='color:" + c + "!important;font-size:30px;'></i><div class='rp_lc'><span class='insta-likes'><i class='far fa-heart'></i>" + r[e] + "</span><span class='insta-comments'><i class='fa fa-comment'></i>" + o[e] + "</span></div></div>")), "icon_caption" == v) {
                            var n = jQuery.trim(a[e]).substring(0, 15);
                            null == a[e] && ("instagram" == M && $(this).append("<div class='rap__med__overlay-hover'><i class='fab fa-instagram' style='color:" + c + "!important;font-size:30px;'></i></div>"), "facebook" == M && $(this).append("<div class='rap__med__overlay-hover'><i class='fab fa-instagram' style='color:" + c + "!important;font-size:30px;'></i><div class='rp_lc'><span class='insta-likes'><i class='far fa-heart'></i>" + r[e] + "</span><span class='insta-comments'><i class='fa fa-comment'></i>" + o[e] + "</span></div></div>")), null != a[e] && ("instagram" == M && $(this).append("<div class='rap__med__overlay-hover'><i class='fab fa-instagram' style='color:" + c + "!important;font-size:30px;'></i><div class='rap_small_caption'  style='word-wrap: break-word; '>" + n + "</div></div>"), "facebook" == M && $(this).append("<div class='rap__med__overlay-hover'><i class='fab fa-instagram' style='color:" + c + "!important;font-size:30px;'></i><div class='rap_small_caption'  style='word-wrap: break-word; '>" + n + "</div><div class='rp_lc'><span class='insta-likes'><i class='far fa-heart'></i>" + r[e] + "</span><span class='insta-comments'><i class='fa fa-comment'></i>" + o[e] + "</span></div></div>"))
                        }
                        if ("caption" == v && (null == a[e] && ("instagram" == M && $(this).append("<div class='rap__med__overlay-top'><div class='rp_caption_bottom'><i class='fab fa-instagram' style='color:" + c + "!important;font-size:30px;'></i></div></div>"), "facebook" == M && $(this).append("<div class='rap__med__overlay-top'><div class='rp_caption_bottom'><span class='insta-likes'><i class='far fa-heart'></i>" + r[e] + "</span><span class='insta-comments'><i class='fa fa-comment'></i>" + o[e] + "</span></div></div>")), null != a[e])) {
                            n = jQuery.trim(a[e]).substring(0, 125);
                            "instagram" == M && $(this).append("<div class='rap__med__overlay-top'><div class='rap_large_caption'  style='word-wrap: break-word; '>" + n + "</div></div><div class='rp_caption_bottom'><i class='fab fa-instagram' style='color:" + c + "!important;font-size:30px;'></i></div>"), "facebook" == M && $(this).append("<div class='rap__med__overlay-top'><div class='rap_large_caption'  style='word-wrap: break-word; '>" + n + "</div></div><div class='rp_caption_bottom'><span class='insta-likes'><i class='far fa-heart'></i>" + r[e] + "</span><span class='insta-comments'><i class='fa fa-comment'></i>" + o[e] + "</span></div>")
                        }
                        if ("caption1" == v && (null == a[e] && ("instagram" == M && $(this).append("<div class='rap__med__overlay-top'><div class='rp_caption_bottom'><i class='fab fa-instagram' style='color:" + c + "!important;font-size:30px;'></i></div><div class='insta_date'>" + s[e] + "</div></div>"), "facebook" == M && $(this).append("<div class='rap__med__overlay-top'><div class='rp_caption_bottom'><span class='insta-likes'><i class='far fa-heart'></i>" + r[e] + "</span><span class='insta-comments'><i class='fa fa-comment'></i>" + o[e] + "</span></div><div class='insta_date'>" + s[e] + "</div></div>")), null != a[e])) {
                            n = jQuery.trim(a[e]).substring(0, 90);
                            "instagram" == M && $(this).append("<div class='rp_caption_bottom'><i class='fab fa-instagram' style='color:" + c + "!important;font-size:30px;'></i></div><div class='rap__med__overlay-top'><div class='rap_large_caption'  style='word-wrap: break-word; '>" + n + "</div><div class='insta_date'>" + s[e] + "</div></div>"), "facebook" == M && $(this).append("<div class='rp_caption_bottom'><span class='insta-likes'><i class='far fa-heart'></i>" + r[e] + "</span><span class='insta-comments'><i class='fa fa-comment'></i>" + o[e] + "</span></div><div class='rap__med__overlay-top'><div class='rap_large_caption'  style='word-wrap: break-word; '>" + n + "</div><div class='insta_date'>" + s[e] + "</div></div>")
                        }
                    }), "old" == u && $(".rap__med__overlay-hover .fa-instagram").replaceWith("<i class='fa fa-instagram' style='color:" + c + "!important;font-size:30px;'></i>"), "old" == u && $(".rap__med__insta_overlay .fa-instagram").replaceWith("<i class='fa fa-instagram' style='color:" + c + "!important;font-size:30px;'></i>"), $.each(rep__insta__imgspopup, function(e, t) {
                        0 <= navigator.userAgent.search("Chrome") || 0 <= navigator.userAgent.search("Safari") || 0 < navigator.userAgent.search("Mozilla") ? (null != g[e] && ($(".rap__med__insta__popup").append("<div class='rap__med__insta__col__l'><video width='600' height='600' controls='true' autoplay='false' id='iframe" + [e] + "' class='instavideoen'><source src='" + g[e] + "' type='video/mp4'></video></div>"), $("#iframe" + [e]).get(0).pause()), null == g[e] && $(".rap__med__insta__popup").append("<div class='rap__med__insta__col__l'><img src='" + rep__insta__imgspopup[e] + "'></div>")) : $(".rap__med__insta__popup").append("<div class='rap__med__insta__col__l'><img src='" + rep__insta__imgspopup[e] + "'></div>")
                    }), $(".rap__med__insta__popup .rap__med__insta__col__l").each(function(e, t) {
                        $(this).wrap("<div class='rap__med__instapopup_main'></div>")
                    }), $(".rap__med__insta__popup .rap__med__instapopup_main").each(function(e, t) {
                        $(this).wrap("<div class='rap__med__insta'></div>")
                    }), $(".rap__med__insta__popup .rap__med__instapopup_main").each(function(e, t) {
                        $(this).append("<div class='rap__med__insta__col__2'></div>")
                    }), $(".rap__med__insta__popup .rap__med__insta__col__2").each(function(e, t) {
                        $(this).append("<div class='rap__med__instapopuphead' style='color:#000;'><div class='rap__med__head_0'><span class='insta-link'><a href='https://instagram.com/" + D + "'  target='_blank'><img src='" + j + "' height='40' width='40' style='float: left; border-radius: 20px;'/></span><span style='padding-top: 12px; font-weight: 600; font-size: 14px;'>" + D + "</span></a><span class='insta-follow'><a href='https://instagram.com/" + D + "' target='_blank'>Follow Us</a></span></div><div class='rap__med__head_1'><span class='insta-likes'><i class='far fa-heart'></i><b>" + r[e] + "</b></span><span class='insta-comments'><i class='fa fa-comment'></i><b>" + o[e] + "</b></span><span class='insta-date' style='float: right; font-size: 10px; text-transform: uppercase; letter-spacing: 0.4px; margin-top: -5px; padding-right: 10px;'>" + s[e] + "</div></div></div>")
                    }), $(".rap__med__insta__popup .rap__med__insta__col__2").each(function(e, t) {
                        null == a[e] && $(this).append("<div class='rap__med__wrap__cont' style='color:#000;'></div>"), null != a[e] && $(this).append("<div class='rap__med__wrap__cont'  style='color:#000;word-wrap: break-word; '>" + a[e] + "</div>")
                    }), $(".rap__med__insta__popup .rap__med__insta__col__2").each(function(e, t) {
                        $(this).append("<div class='rap__med__insta_footer'><div class='rap__med__socialicons'><a href='https://www.facebook.com/sharer/sharer.php?u=" + i[e] + "' target='_blank'><i class='fab fa-facebook'></i></a><a href='https://twitter.com/home?status=" + i[e] + "' target='_blank'><i class='fab fa-twitter'></i></a><a href='https://plus.google.com/share?url=" + i[e] + "' target='_blank'><i class='fab fa-google-plus'></i></a><a href='https://pinterest.com/pin/create/button/?media=" + rep__insta__imgspopup[e] + "&description=" + i[e] + "' target='_blank'><i class='fab fa-pinterest'></i></a></div></div>")
                    }), $(".rap__med__insta__popup .rap__med__insta").each(function(e, t) {
                        $(this).wrap("<div class='rap__med__instaoverlay' id='rap__med__insta" + [e] + "'></div>"), $(this).append("<div class='rap__med__instanav' style='float: left; width: 100%;position: absolute; top:49%; text-align: right; font-size: 60px;font-family:open sans;font-weight: 100; line-height:60px;'><a id='raptor__insta__prev__" + [e - 1] + "' class='rap__med__insta-prev ' style='cursor: pointer;color:#ccc;position: relative; left: -80px; float: left; font-weight: 100!important;'>&lsaquo;</a><a id='raptor__insta__next__" + [e + 1] + "' class='rap__med__insta-next ' style='cursor: pointer; color:#ccc; position: relative; right: -80px; float: right;font-weight: 100!important;'>&rsaquo;</a></div>"), $("#close-" + [e]).click(function() {
                            $("#rap__med__insta" + [e]).css("opacity", "0"), $("#rap__med__insta" + [e]).css("display", "none"), $("#rap__med__insta" + [e]).removeClass("acivePopup"), null != g[e] && $("#iframe" + [e]).get(0).pause()
                        }), $("#raptor__insta__prev__" + [e - 1]).click(function() {
                            $("#rap__med__insta" + [e]).css("opacity", "0"), $("#rap__med__insta" + [e]).css("display", "none"), $("#rap__med__insta" + [e]).removeClass("acivePopup"), $("#rap__med__insta" + [e - 1]).css("opacity", "1"), $("#rap__med__insta" + [e - 1]).css("display", "block"), $("#rap__med__insta" + [e - 1]).addClass("acivePopup"), null != g[e] && $("#iframe" + [e]).get(0).pause()
                        }), $("#raptor__insta__next__" + [e + 1]).click(function() {
                            $("#rap__med__insta" + [e]).css("opacity", "0"), $("#rap__med__insta" + [e]).css("display", "none"), $("#rap__med__insta" + [e]).removeClass("acivePopup"), $("#rap__med__insta" + [e + 1]).css("opacity", "1"), $("#rap__med__insta" + [e + 1]).css("display", "block"), $("#rap__med__insta" + [e + 1]).addClass("acivePopup"), null != g[e] && $("#iframe" + [e]).get(0).pause()
                        })
                    }), $(".rap__med__insta__popup .rap__med__instaoverlay").each(function(e, t) {
                        $(this).prepend("<a class='rap__med__close raptor__close_button' id='close" + [e] + "'>&times;</a>")
                    }), $("#rap__med__insta .rap__med__wrap__inside").each(function(e, t) {
                        $("#rap__med__onclick__" + [e]).click(function() {
                            $("#rap__med__insta" + [e]).css("opacity", "1"), $("#rap__med__insta" + [e]).css("display", "block"), $("#rap__med__insta" + [e]).addClass("acivePopup fade-in")
                        })
                    }), $(".rap__med__instaoverlay .rap__med__close").each(function(e, t) {
                        $("#close" + [e]).click(function() {
                            $("#rap__med__insta" + [e]).css("opacity", "0"), $("#rap__med__insta" + [e]).css("display", "none"), $("#rap__med__insta" + [e]).removeClass("acivePopup fade-in"), null != g[e] && $("#iframe" + [e]).get(0).pause()
                        })
                    }), 1024 <= screen.width && $("<style>#page{-webkit-perspective:0;perspective:0;}</style>").appendTo("body")
                })
            }), $(document).ready(function() {
                var e = setInterval(function() {
                    $("#rap__med__insta").length && ($(window).trigger("resize"), clearInterval(e))
                }, 500)
            }), "old" == u && ($(".insta-likes .far").replaceWith("<i class='fa fa-heart-o'></i>"), $(".fa-facebook").replaceWith("<i class='fa fa-facebook'></i>"), $(".fa-twitter").replaceWith("<i class='fa fa-twitter'></i>"), $(".fa-pinterest").replaceWith("<i class='fa fa-pinterest'></i>"), $(".fa-google-plus").replaceWith("<i class='fa fa-google-plus'></i>")), "grid" == p && ($("<style>@media screen and (max-width: 736px){.rap__med__insta-img{height:218px!important;}}</style>").appendTo("body"), $("<style>@media screen and (max-width: 414px){.rap__med__insta-img{height:184px!important;}}</style>").appendTo("body")), $("<style>" + b + "</style>").appendTo("body")
        }
    })
}
function_call(shop);